import { Observable as e, useObservable as t } from "thrive-observable-react";
import { createContext as n, useContext as r, useEffect as i, useMemo as a, useRef as o, useState as s } from "react";
import { AddFormOptionButton as c, AddImageFromMediaLibrary as l, AdditionOptionsContainer as u, BasicButton as d, BasicCheckbox as f, BasicFormElementModal as p, BasicTextInput as m, ConditionCheckboxPanel as h, ConditionalEmailPanel as g, ConditonalLogicPanel as _, FormButtonElement as v, FormElementListWrapper as ee, FormElementSelectMenu as y, FormElementWidget as b, FullWidthActionButton as te, IFormElementType as x, IconButtonWithTooltip as ne, IconLibrary as S, InformationContainer as C, LargerRadioButton as re, ThriveIcon as ie } from "thrive-components";
import { Fragment as w, jsx as T, jsxs as E } from "react/jsx-runtime";
//#region src/interfaces/FormElements.ts
var D = /* @__PURE__ */ function(e) {
	return e.REQUIRED = "required", e.MAXFILESIZE = "maxFileSize", e.ACCEPTEDFILETYPE = "acceptedFileType", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.PHOTOS = "photos", e.TEXTENTRY = "textEntry", e.TEXTAREA = "textarea", e.DROPDOWN = "dropdown", e.ORGUSERSEARCH = "orgUserSearch", e.ORGTEAMSEARCH = "orgTeamSearch", e.SINGLEOPTION = "singleOption", e.CHECKBOX = "checkbox", e.VIDEOS = "videos", e.FILES = "files", e.SINGLESELECT = "singleSelect", e.POLL = "poll", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.NONE = "none", e.TWO_COLUMN = "twoColumns", e.INLINE = "inline", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.NONE = "none", e.OR = "or", e.AND = "and", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.EQUAL = "equal", e.NOTEQUAL = "notEqual", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.SHOW = "show", e.ENABLE = "enable", e.SENDWHEN = "sendWhen", e;
}({}), ae = /* @__PURE__ */ function(e) {
	return e.NONE = "none", e.TEXT = "text", e.NUMERIC = "numeric", e;
}({}), oe = [];
function N() {
	let e;
	do
		e = Math.floor(Math.random() * 1e6) + 1;
	while (oe.includes(e));
	return oe.push(e), e;
}
function se(e) {
	switch (e) {
		case O.PHOTOS: return [
			"bmp",
			"gif",
			"ico",
			"jpeg",
			"jpg",
			"png",
			"webp"
		];
		case O.VIDEOS: return [
			"mov",
			"mp4",
			"qt"
		];
		case O.FILES: return /* @__PURE__ */ "7z.bmp.css.csv.doc.docm.docx.dot.dotm.dotx.fodg.fodp.fods.fodt.gif.ico.jpeg.jpg.json.m4a.mov.mp3.mp4.odf.odg.odp.ods.odt.ott.pdf.png.ppa.pps.ppsm.ppsx.ppt.pptm.pptx.psd.pub.qt.r00.r01.rar.rev.rtf.sldx.svg.svgz.txt.vcard.vcf.vsd.vsdx.wav.wave.webp.xla.xls.xlsb.xlsm.xlsx.xlt.xltm.xltx.xml.zip".split(".");
		default: return [];
	}
}
function ce(e) {
	switch (e) {
		case O.PHOTOS: return "File type not accepted. Accepted file types: .bmp, .gif, .ico, .jpeg, .jpg, .png, .webp";
		case O.VIDEOS: return "File type not accepted. Accepted file types: .mov, .mp4, .qt";
		case O.FILES: return "File type not accepted. Accepted file types: .7z, .bmp, .css, .csv, .doc, .docm, .docx, .dot, .dotm, .dotx, .fodg, .fodp, .fods, .fodt, .gif, .ico, .jpeg, .jpg, .json, .m4a, .mov, .mp3, .mp4, .odf, .odg, .odp, .ods, .odt, .ott, .pdf, .png, .ppa, .pps, .ppsm, .ppsx, .ppt, .pptm, .pptx, .psd, .pub, .qt, .r00, .r01, .rar, .rev, .rtf, .sldx, .svg, .svgz, .txt, .vcard, .vcf, .vsd, .vsdx, .wav, .wave, .webp, .xla, .xls, .xlsb, .xlsm, .xlsx, .xlt, .xltm, .xltx, .xml, .zip";
	}
}
var le = {
	id: 0,
	combinator: "none",
	condition: {
		elementId: -1,
		conditionType: "",
		conditionValueType: "text",
		value: ""
	}
};
//#endregion
//#region src/utils/rules.ts
function ue(e) {
	return e === O.DROPDOWN || e === O.ORGUSERSEARCH || e === O.SINGLEOPTION ? ae.NUMERIC : ae.TEXT;
}
function de(e, t, n, r) {
	if (r.elements.getElement(n)?.type === O.CHECKBOX && e === j.EQUAL) {
		if (t === "True") return "isChecked";
		if (t === "False") return "isNotChecked";
	}
	return e === j.EQUAL && t === "" ? "isEmpty" : e === j.NOTEQUAL && t === "" ? "isNotEmpty" : e;
}
var fe = {
	id: 0,
	expression1: void 0,
	expression2: void 0,
	combinator: A.NONE,
	condition: {
		elementId: -1,
		conditionType: "",
		conditionValueType: "text",
		conditionMetaType: "",
		value: ""
	}
}, pe = (e) => e ? {
	isEmpty: {
		conditionType: j.EQUAL,
		value: ""
	},
	isNotEmpty: {
		conditionType: j.NOTEQUAL,
		value: ""
	},
	isChecked: {
		conditionType: j.EQUAL,
		value: "True"
	},
	isNotChecked: {
		conditionType: j.EQUAL,
		value: "False"
	}
}[e] : {};
//#endregion
//#region src/utils/treeTraversal.ts
function P(e, t) {
	if (!e) return [];
	if (e.combinator == A.NONE) return [e.id];
	let n = [];
	return n = [...n, ...P(t[e.expression1], t)], n = [...n, ...P(t[e.expression2], t)], n;
}
function F(e, t) {
	return !e || e.combinator === A.NONE || e.combinator === A.OR && F(t[e.expression1], t) && F(t[e.expression2], t);
}
function I(e, t, n) {
	return e ? (e.combinator === A.AND ? (I(n[e.expression1], t, n), I(n[e.expression2], t, n)) : t.push(e.id), t) : [];
}
function me(e) {
	return he(P(e[0], e).map((t) => e[t]));
}
function he(e) {
	let t = {}, n = [];
	for (let r of e) {
		let e = `${r?.condition?.elementId}${r?.condition?.conditionMetaType}`;
		t[e] ? t[e] = [...t[e], r] : t[e] = [r], n.includes(e) || n.push(e);
	}
	return n.map((e) => t[e]);
}
function ge(e, t) {
	return Array.from(Object.values(e)).find((e) => e.expression1 === Number(t) || e.expression2 === Number(t));
}
function _e(e, t, n) {
	let r = {
		...e,
		id: N()
	}, i = { ...t }, a = {
		id: e.id,
		expression1: r.id,
		expression2: i.id,
		condition: void 0,
		combinator: A.OR
	}, o = {
		...n,
		[r.id]: r,
		[i.id]: i
	};
	return o[e.id] = a, o;
}
function ve(e, t, n) {
	let r = {
		...e[0],
		id: N()
	}, i = { ...t }, a = {
		id: 0,
		expression1: r.id,
		expression2: i.id,
		condition: void 0,
		combinator: n
	};
	return e = {
		...e,
		[i.id]: i,
		[r.id]: r
	}, e[0] = a, e;
}
function ye(e, t) {
	let n = e.map((e) => e[0].id), r = e.map(() => ({})), i, a = {};
	return e.forEach((e, o) => {
		e.forEach((e, t) => {
			t === 0 ? r[o][e.id] = e : r[o] = _e(i, e, { ...r[o] }), i = e;
		}), a = {
			...a,
			...r[o]
		}, o === 0 ? a[0] = {
			...a[n[o]],
			id: 0
		} : a = ve(a, a[n[o]], t);
	}), delete a[n[0]], a;
}
function L(e, t, n) {
	let r = {
		...e,
		condition: e.condition?.conditionType ? {
			...e.condition,
			conditionMetaType: de(e.condition.conditionType, e.condition.value, e.condition.elementId, n)
		} : null
	};
	return e?.expression1 && typeof e?.expression1 != "number" && (r.expression1 = (e?.expression1).id, t = {
		...t,
		...L(e.expression1, t, n)
	}), e?.expression2 && typeof e?.expression2 != "number" && (r.expression2 = (e?.expression2).id, t = {
		...t,
		...L(e.expression2, t, n)
	}), t = {
		...t,
		[e.id]: r
	}, t;
}
//#endregion
//#region src/utils/validation.ts
var be = (e) => e.trim() === "", xe = (e, t, n) => {
	let r = n.elements.getElementsBeforeId(e).map((e) => e.id), i = !1;
	for (let e of Object.values(t)) e.condition?.elementId && e.condition?.elementId > 0 && !r.includes(e.condition?.elementId) && (i = !0);
	return i;
}, Se = (e) => {
	for (let t of Object.values(e)) if (!(t.combinator === A.AND || t.combinator === A.OR) && (!t.condition?.elementId && !t.condition?.conditionMetaType && !t.condition?.conditionType || t.condition?.elementId === -1 || t.condition?.conditionType === "" || t.condition?.conditionMetaType === "")) return !0;
	return !1;
}, Ce = (e) => e.rules.find((e) => e.ruleType === M.SHOW), R = (e, t, n) => !!(e && xe(t, L(e.expression, {}, n), n)), z = (e, t) => !!(e && Se(L(e.expression, {}, t)));
function we(e, t) {
	return t.dirtyElements.value.includes(e);
}
var B = /* @__PURE__ */ function(e) {
	return e.TITLE_IS_REQUIRED = "titleIsRequired", e.RULES_ARE_INVALID = "rulesAreInvalid", e.RULES_ARE_INCOMPLETE = "rulesAreIncomplete", e.DROPDOWN_REQUIRES_OPTIONSETS = "dropDownRequiresOptionSets", e.MUST_HAVE_AT_LEAST_1_OPTION = "mustHaveAtLeastOneOption", e.OPTIONS_MUST_HAVE_LABEL_TEXT = "optionsMustHaveLabelText", e.CONDITIONAL_EXPRESSION_IS_INVALID = "condtionalExpressionIsInvalid", e.CONDITIONAL_EXPRESSION_IS_INCOMPLETE = "condtionalExpressionIsIncomplete", e.AT_LEAST_1_EMAIL_ADDRESS_IS_REQUIRED = "atLeastOneEmailAddressIsRequired", e.MAX_LENGTH_512 = "maxLength512", e.MAX_LENGTH_20 = "maxLength20", e;
}({}), Te = (e, t, n) => {
	let r = [];
	return R(e, t, n) && r.push("rulesAreInvalid"), z(e, n) && r.push("rulesAreIncomplete"), r;
}, Ee = (e, t = !1, n) => {
	let r = we(e.id, n), i = [];
	if (R(Ce(e), e.id, n) && i.push("rulesAreInvalid"), !r && !t) return i;
	{
		let t = e.title, r = be(t), a = t.length > 512, o = R(Ce(e), e.id, n);
		r && i.push("titleIsRequired"), o && i.push("rulesAreInvalid"), a && i.push("maxLength512"), e.type === O.TEXTAREA && e.placeholder?.length > 155 && i.push("maxLength512"), (e.type === O.TEXTENTRY || e.type === O.ORGUSERSEARCH || e.type === O.DROPDOWN) && e.placeholder?.length > 35 && i.push("maxLength512"), (e.type === O.VIDEOS || e.type === O.PHOTOS || e.type === O.FILES) && e.title.length > 20 && i.push("maxLength512"), (e.type === O.DROPDOWN || e.type === O.SINGLESELECT || e.type === O.POLL) && i.push(...De(e, n)), e.type === O.SINGLEOPTION && i.push(...Oe(e));
		let s = z(Ce(e), n);
		if (e.type === O.SINGLESELECT || e.type === O.POLL) {
			let t = e?.elementSubmitButtonText;
			e.elementSubmitButtonText && (t.trim().length === 0 && i.push("titleIsRequired"), t.length > 20 && i.push("maxLength20"));
		}
		s && i.push("rulesAreIncomplete");
	}
	return i;
}, De = (e, t) => {
	let n = 25;
	if ((e.type === O.POLL || e.type === O.SINGLESELECT) && (n = 256), e.optionSets.length === 0) return ["dropDownRequiresOptionSets"];
	{
		let r = [];
		return e.optionSets.forEach((i) => {
			if (i.options.length === 0) r.push("mustHaveAtLeastOneOption");
			else {
				let e = i.options.map((e) => e.label).filter((e) => e);
				e.length < i.options.length && r.push("optionsMustHaveLabelText"), e.some((e) => e.length > n) && r.push("maxLength512");
			}
			i.conditionalExpression && (R({
				expression: i.conditionalExpression,
				ruleType: M.SHOW
			}, e.id, t) && r.push("condtionalExpressionIsInvalid"), z({
				expression: i.conditionalExpression,
				ruleType: M.SHOW
			}, t) && r.push("condtionalExpressionIsIncomplete"));
		}), r;
	}
}, Oe = (e) => {
	if (e.options.length === 0) return ["mustHaveAtLeastOneOption"];
	let t = [], n = e.options.map((e) => e.label).filter((e) => e);
	return n.length < e.options.length && t.push("optionsMustHaveLabelText"), n.some((e) => e.length > 20) && t.push("maxLength512"), t;
}, ke = (e) => e === O.TEXTAREA ? 155 : 35;
//#endregion
//#region src/utils/formElement.ts
function Ae() {
	return {
		type: O.TEXTENTRY,
		placeholder: "",
		defaultValue: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "",
			value: !1
		}],
		rules: []
	};
}
function je() {
	return {
		type: O.TEXTAREA,
		placeholder: "",
		defaultValue: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "",
			value: !1
		}],
		rules: []
	};
}
function Me() {
	return {
		type: O.PHOTOS,
		caption: {
			enabled: !1,
			title: "Image Caption",
			placeholder: "Please enter a caption for your image"
		},
		maxFileCount: 10,
		buttonText: "",
		id: 0,
		title: "",
		validation: [
			{
				validationType: D.MAXFILESIZE,
				errorMessage: "File size too large. Please upload a file no larger than 1 GiB",
				value: 1073741824
			},
			{
				validationType: D.ACCEPTEDFILETYPE,
				errorMessage: "File type not accepted. Accepted file types: .bmp, .gif, .ico, .jpeg, .jpg, .png, .webp",
				value: [
					"bmp",
					"gif",
					"ico",
					"jpeg",
					"jpg",
					"png",
					"webp"
				]
			},
			{
				validationType: D.REQUIRED,
				errorMessage: "This Field is Required",
				value: !1
			}
		],
		rules: []
	};
}
function Ne() {
	return {
		type: O.VIDEOS,
		maxFileCount: 5,
		buttonText: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.MAXFILESIZE,
			errorMessage: "File size too large. Please upload a file no larger than 1 GiB",
			value: 1073741824
		}, {
			validationType: D.ACCEPTEDFILETYPE,
			errorMessage: "File type not accepted. Accepted file types: .mov, .mp4, .qt",
			value: [
				"mov",
				"mp4",
				"qt"
			]
		}],
		rules: []
	};
}
function Pe() {
	return {
		type: O.FILES,
		maxFileCount: 5,
		buttonText: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.MAXFILESIZE,
			errorMessage: "File size too large. Please upload a file no larger than 100 MiB",
			value: 104857600
		}, {
			validationType: D.ACCEPTEDFILETYPE,
			errorMessage: "File type not accepted. Accepted file types: .7z, .bmp, .css, .csv, .doc, .docm, .docx, .dot, .dotm, .dotx, .fodg, .fodp, .fods, .fodt, .gif, .ico, .jpeg, .jpg, .json, .m4a, .mov, .mp3, .mp4, .odf, .odg, .odp, .ods, .odt, .ott, .pdf, .png, .ppa, .pps, .ppsm, .ppsx, .ppt, .pptm, .pptx, .psd, .pub, .qt, .r00, .r01, .rar, .rev, .rtf, .sldx, .svg, .svgz, .txt, .vcard, .vcf, .vsd, .vsdx, .wav, .wave, .webp, .xla, .xls, .xlsb, .xlsm, .xlsx, .xlt, .xltm, .xltx, .xml, .zip",
			value: se(O.FILES)
		}],
		rules: []
	};
}
function Fe() {
	return {
		type: O.DROPDOWN,
		optionSets: [{
			id: N(),
			options: [{
				id: N(),
				label: "",
				value: N()
			}, {
				id: N(),
				label: "",
				value: N()
			}],
			conditionalExpression: void 0
		}],
		placeholder: "",
		defaultValue: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "This field is required",
			value: !1
		}],
		rules: []
	};
}
function Ie() {
	return {
		description: "",
		elementSubmitButtonText: "Vote",
		showResultsAfterVoting: !1,
		imageLayout: k.NONE,
		type: O.SINGLESELECT,
		optionSets: [{
			id: N(),
			options: [{
				id: N(),
				label: "",
				value: N(),
				description: "",
				imageAsset: void 0
			}, {
				id: N(),
				label: "",
				value: N(),
				description: "",
				imageAsset: void 0
			}],
			conditionalExpression: void 0
		}],
		placeholder: "",
		defaultValue: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "This field is required",
			value: !1
		}],
		rules: []
	};
}
function Le() {
	return {
		type: O.ORGUSERSEARCH,
		department: "",
		placeholder: "",
		defaultValue: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "This field is required",
			value: !1
		}],
		rules: []
	};
}
function Re() {
	return {
		type: O.SINGLEOPTION,
		options: [{
			id: N(),
			label: "",
			value: N()
		}, {
			id: N(),
			label: "",
			value: N()
		}],
		defaultValue: 0,
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "This field is required",
			value: !1
		}],
		rules: []
	};
}
function ze() {
	return {
		type: O.CHECKBOX,
		placeholder: "",
		defaultValue: "",
		id: 0,
		title: "",
		validation: [{
			validationType: D.REQUIRED,
			errorMessage: "This field is required",
			value: !1
		}],
		rules: []
	};
}
function Be(e, t) {
	return e ? {
		[j.EQUAL]: {
			id: 1,
			isDisabled: !1,
			label: "equal to",
			onButtonClick: () => t(),
			text: "equal to",
			contentMetaType: "equal"
		},
		[j.NOTEQUAL]: {
			id: 2,
			isDisabled: !1,
			label: "not equal to",
			onButtonClick: () => t(),
			text: " not equal to",
			contentMetaType: "notEqual"
		},
		isEmpty: {
			id: 3,
			isDisabled: !1,
			label: "is empty",
			onButtonClick: () => t(),
			text: "empty",
			contentMetaType: "isEmpty"
		},
		isNotEmpty: {
			id: 4,
			isDisabled: !1,
			label: "is not empty",
			onButtonClick: () => t(),
			text: "not empty",
			contentMetaType: "isNotEmpty"
		},
		isChecked: {
			id: 5,
			isDisabled: !1,
			label: "is checked",
			onButtonClick: () => t(),
			text: "is checked",
			contentMetaType: "isChecked"
		},
		isNotChecked: {
			id: 5,
			isDisabled: !1,
			label: "is not checked",
			onButtonClick: () => t(),
			text: "is not checked",
			contentMetaType: "isNotChecked"
		}
	}[e] : {};
}
//#endregion
//#region src/service/models/formElement.model.ts
var V = class {
	id;
	type;
	title = e("");
	isRequired = e(!1);
	rules = e({});
	conditionalRule = e(!1);
	FBService;
	constructor(e, t) {
		this.id = e.id || N(), this.title.update(e.title), this.type = e.type;
		let n = e.validation.find((e) => e.validationType === D.REQUIRED)?.value;
		this.isRequired.update(!!n);
		let r = {};
		for (let t of e.rules) r[t.ruleType] = t;
		this.rules.update(r), this.conditionalRule.update(e.rules.length >= 1), this.FBService = t;
	}
	setTitle = (e) => {
		this.title.update(e);
	};
	setIsRequired = (e) => {
		this.isRequired.update(e);
	};
	setConditionalRule = (e) => {
		if (e === !1) {
			let e = this.rules.value;
			delete e[M.SHOW], this.rules.update(e);
		}
		this.conditionalRule.update(e);
	};
	getValidation = () => {
		let e = [];
		return this.isRequired.value && e.push({
			validationType: D.REQUIRED,
			errorMessage: "This field is required",
			value: this.isRequired.value
		}), e;
	};
	formatRules = () => this.conditionalRule.value ? [this.rules.value[M.SHOW]].filter((e) => e) : [];
	addRules = (e) => {
		if (Object.keys(e.expression).length === 0) this.rules.update({});
		else {
			let t = {};
			t[M.SHOW] = e, this.rules.update(t);
		}
	};
}, H = class extends V {
	placeholder = e("");
	defaultValue = e("");
	optionSet = e([]);
	constructor(e, t) {
		super(e, t), this.placeholder.update(e.placeholder ?? ""), this.defaultValue.update(e.defaultValue), this.optionSet.update(e.optionSets);
	}
	addOption = (e) => {
		let t = this.optionSet.value.map((t) => t.id === e ? {
			...t,
			options: [...t.options, {
				id: N(),
				label: "",
				value: N()
			}]
		} : t);
		this.optionSet.update(t);
	};
	removeOption = (e, t) => {
		let n = this.optionSet.value.map((n) => n.id === e ? {
			...n,
			options: n.options.filter((e) => e.id !== t)
		} : n);
		this.optionSet.update(n);
	};
	removeOptionSet = (e) => {
		let t = this.optionSet.value.filter((t) => t.id !== e);
		t.length === 1 && (t[0].conditionalExpression = void 0), this.optionSet.update(t);
	};
	setValue = (e, t, n, r) => {
		let i = this.optionSet.value.find((t) => t.id === e), a = i?.options.find((e) => e.id === t), o = i?.options.map((e) => e.id === t ? {
			...a,
			[r]: n
		} : e);
		this.optionSet.update(this.optionSet.value.map((t) => t.id === e ? {
			...t,
			options: o
		} : t));
	};
	setPlaceholder = (e) => {
		this.placeholder.update(e);
	};
	addExpressionToOptionSet = (e, t) => {
		let n = this.optionSet.value.map((n) => n.id === e ? {
			...n,
			conditionalExpression: t
		} : n);
		this.optionSet.update(n);
	};
	formatToFormData = () => ({
		type: this.type,
		optionSets: this.optionSet.value,
		placeholder: this.isRequired.value ? this.placeholder.value : void 0,
		defaultValue: this.defaultValue.value,
		id: this.id,
		title: this.title.value,
		validation: this.getValidation(),
		rules: this.formatRules()
	});
	addToForm = () => {
		this.FBService.elements.addNewDropdown(this.formatToFormData()), this.FBService.elements.setShowAddNewWidgets(!1);
	};
	updateForm = () => {
		let e = this.formatToFormData();
		this.FBService.elements.updateElement(this.id, e);
	};
	addOptionSet = () => {
		this.optionSet.update([...this.optionSet.value, {
			id: N(),
			options: [{
				id: N(),
				label: "",
				value: N()
			}, {
				id: N(),
				label: "",
				value: N()
			}],
			conditionalExpression: le
		}]);
	};
}, U = {}, Ve = "data:image/png;base64,broken", He = (e) => ({
	assetId: e,
	url: Ve,
	filename: ""
}), Ue = (e) => ({
	assetId: String(e.id ?? e.assetId),
	url: e.location ?? e.uri ?? e.url,
	filename: e.filename ?? e.title
}), W = class extends H {
	description = e("");
	elementSubmitButtonText = e("");
	imageLayout = e(k.NONE);
	showResultsAfterVoting = e(!1);
	imageAssets = e({});
	constructor(e, t) {
		super(e, t), this.description.update(e.description ?? ""), this.elementSubmitButtonText.update(e.elementSubmitButtonText ?? "Vote"), this.imageLayout.update(e.imageLayoutKind ?? k.NONE), this.showResultsAfterVoting.update(e.showResultsAfterVoting ?? !1), this.loadMissingImageAssets();
	}
	setImageAsset = (e) => {
		this.imageAssets.update({
			...this.imageAssets.value,
			[e.assetId]: e
		});
	};
	loadMissingImageAssets = async () => {
		let e = /* @__PURE__ */ new Set();
		this.optionSet.value.forEach((t) => t.options.forEach((t) => {
			t.imageAssetId && !this.imageAssets.value[t.imageAssetId] && e.add(String(t.imageAssetId));
		}));
		let t = this.FBService.config?.getAssetDetailsFromMediaLibrary;
		if (!t || e.size === 0) return;
		let n = await Promise.all([...e].map(async (e) => {
			if (U[e]) return {
				id: e,
				asset: U[e]
			};
			try {
				let n = await t(Number(e));
				if (!n) return;
				let r = Ue(n);
				return U[e] = r, {
					id: e,
					asset: r
				};
			} catch (t) {
				return console.error(`Failed to load image asset ${e}`, t), {
					id: e,
					asset: He(e)
				};
			}
		})), r = { ...this.imageAssets.value };
		n.forEach((e) => {
			e && (r[e.id] = e.asset);
		}), this.imageAssets.update(r);
	};
	setDescription(e) {
		this.description.update(e);
	}
	setElementSubmitButtonText(e) {
		this.elementSubmitButtonText.update(e);
	}
	setImageLayout(e) {
		this.imageLayout.update(e);
	}
	setShowResultsAfterVoting(e) {
		this.showResultsAfterVoting.update(e);
	}
	formatToFormSSEData = () => ({
		type: this.type,
		description: this.description.value,
		imageLayoutKind: this.imageLayout.value,
		optionSets: this.optionSet.value,
		placeholder: this.isRequired.value ? this.placeholder.value : void 0,
		defaultValue: this.defaultValue.value,
		id: this.id,
		title: this.title.value,
		validation: this.getValidation(),
		rules: this.formatRules(),
		elementSubmitButtonText: this.elementSubmitButtonText.value,
		showResultsAfterVoting: this.showResultsAfterVoting.value
	});
	addToForm = () => {
		this.FBService.elements.addNewSingleSelect(this.formatToFormSSEData()), this.FBService.elements.setShowAddNewWidgets(!1);
	};
	updateForm = () => {
		let e = this.formatToFormSSEData();
		this.FBService.elements.updateElement(this.id, e);
	};
	handleImageUpload = (e, t, n) => {
		n?.config?.handleExternalMediaHandler?.((n) => {
			let r = Ue(n);
			U[r.assetId] = r, this.setImageAsset(r), this.setValue(e, t, r.assetId, "imageAssetId");
		});
	};
	handleRemoveImage = (e, t) => {
		this.setValue(e, t, void 0, "imageAssetId");
	};
};
//#endregion
//#region src/service/formTemplates.service.ts
function We(e) {
	e.email.resetAllEmailDetails(), e.config.setPollConfig(), new W(Ie(), e).addToForm();
}
function Ge(e) {
	e.config.setDefaultConfig();
}
//#endregion
//#region src/service/formElements.service.ts
var G = /* @__PURE__ */ function(e) {
	return e.POLL = "poll", e.NONE = "none", e;
}({}), Ke = class {
	formBuilderData = e([]);
	showAddNewWidgets = e(!1);
	openEditElementId = e([]);
	dirtyElements = e([]);
	FormTemplate = e("none");
	validateForm;
	constructor(e) {
		this.validateForm = e;
	}
	setFormBuilderData = (e) => {
		this.formBuilderData.update(e);
	};
	addNewText = (e) => {
		this.formBuilderData.update([...this.formBuilderData.value, e]), this.showAddNewWidgets.update(!1), this.setEditMode(e.id);
	};
	addNewDropdown = (e) => {
		this.formBuilderData.update([...this.formBuilderData.value, e]), this.showAddNewWidgets.update(!1), this.setEditMode(e.id);
	};
	addNewSingleOption = (e) => {
		this.formBuilderData.update([...this.formBuilderData.value, e]), this.showAddNewWidgets.update(!1), this.setEditMode(e.id);
	};
	addNewSingleSelect = (e) => {
		this.formBuilderData.update([...this.formBuilderData.value, e]), this.showAddNewWidgets.update(!1), this.setEditMode(e.id);
	};
	addNewImage(e) {
		this.formBuilderData.update([...this.formBuilderData.value, e]), this.showAddNewWidgets.update(!1), this.setEditMode(e.id);
	}
	setShowAddNewWidgets = (e) => {
		this.showAddNewWidgets.update(e);
	};
	updateElement(e, t) {
		let n = this.formBuilderData.value.map((n) => n.id === e ? t : n);
		this.formBuilderData.update(n);
	}
	getNumberOfElement() {
		return this.formBuilderData.value.length;
	}
	getElementIndex = (e) => this.formBuilderData.value.findIndex((t) => t.id === e);
	getElement = (e) => this.formBuilderData.value.find((t) => t.id === e);
	setEditMode = (e) => {
		this.addDirtyElement(this.openEditElementId.value), this.openEditElementId.value.includes(e) ? this.openEditElementId.update(this.openEditElementId.value.filter((t) => t !== e)) : this.openEditElementId.update([...this.openEditElementId.value, e]);
	};
	setFormTemplate = (e) => {
		this.FormTemplate.update(e);
	};
	moveElement(e, t) {
		let n = [...this.formBuilderData.value], r = n.splice(e, 1)[0];
		n.splice(t, 0, r), this.formBuilderData.update(n), this.validateForm();
	}
	moveUp(e) {
		let t = this.getElementIndex(e), n = t - 1 < 0 ? this.formBuilderData.value.length - 1 : t - 1;
		this.moveElement(t, n);
	}
	moveDown(e) {
		let t = this.getElementIndex(e), n = t + 1 === this.formBuilderData.value.length ? 0 : t + 1;
		this.moveElement(t, n);
	}
	handleDragAndDrop = (e, t) => {
		this.moveElement(e, t);
	};
	deleteElement(e) {
		let t = this.formBuilderData.value.filter((t) => String(t.id) !== String(e));
		this.formBuilderData.update(t), this.validateForm();
	}
	deleteAllElements() {
		this.formBuilderData.update([]), this.validateForm();
	}
	addDirtyElement = (e) => {
		let t = new Set(this.dirtyElements.value);
		e.every((e) => t.has(e)) || (this.dirtyElements.update(Array.from(/* @__PURE__ */ new Set([...this.dirtyElements.value, ...e]))), this.validateForm());
	};
	isFirstElement = (e) => this.getElementIndex(e) === 0;
	isLastElement = (e) => this.getElementIndex(e) === this.formBuilderData.value.length - 1;
	getElementsBeforeId = (e) => {
		if (!e) return this.formBuilderData.value;
		let t = this.getElementIndex(e);
		return t < 0 ? this.formBuilderData.value : this.formBuilderData.value.slice(0, t);
	};
	applyFormTemplate = (e, t) => {
		switch (e !== t.elements.FormTemplate.value && t.elements.deleteAllElements(), t.elements.FormTemplate.update(e), e) {
			case "poll":
				We(t);
				break;
			case "none":
				Ge(t);
				return;
		}
	};
}, qe = class {
	formSubmitButtonText = e("Submit");
	formTitle = e("");
	viewFormButtonText = e("View Form");
	viewFormElementIsDirty = e(!1);
	submitElementIsDirty = e(!1);
	validateForm;
	constructor(e) {
		this.validateForm = e;
	}
	setSubmitElementIsDirty = (e) => {
		this.submitElementIsDirty.update(e), e && this.validateForm();
	};
	setViewFormElementIsDirty = (e) => {
		this.viewFormElementIsDirty.update(e), e && this.validateForm();
	};
	setFormSubmitButtonText = (e) => {
		this.formSubmitButtonText.update(e);
	};
	setFormTitle = (e) => {
		this.formTitle.update(e);
	};
	setViewFormButtonText = (e) => {
		this.viewFormButtonText.update(e);
	};
}, Je = class {
	emailResponseEnabled = e(!1);
	emailTextInput = e("");
	emailRecipientsList = e([]);
	emailRecipientsListIsDirty = e(!1);
	conditionalEmailRules = e([]);
	conditionalEmailRulesLoaded = e(!1);
	validateForm;
	constructor(e) {
		this.validateForm = e;
	}
	resetAllEmailDetails() {
		this.setEmailResponseEnabled(!1), this.setEmailRecipientsListIsDirty(!1), this.emailTextInput.update(""), this.emailRecipientsList.update([]), this.conditionalEmailRules.update([]);
	}
	setEmailRecipientsListIsDirty = (e) => {
		this.emailRecipientsListIsDirty.update(e), e && this.validateForm();
	};
	setEmailResponseEnabled = (e) => {
		this.setEmailRecipientsListIsDirty(!1), this.emailResponseEnabled.update(e), e || (this.emailRecipientsList.update([]), this.conditionalEmailRules.update([]), this.conditionalEmailRulesLoaded.update(!0));
	};
	setEmailTextInput = (e) => {
		this.setEmailRecipientsListIsDirty(!1), this.emailTextInput.update(e);
	};
	setEmailRecipientsList(e) {
		this.setEmailRecipientsListIsDirty(!1), this.emailRecipientsList.update(e);
	}
	addEmailToEmailRecipientsList(e) {
		let t = e.trim();
		t && (this.emailRecipientsList.value.some((e) => e.toLowerCase() === t.toLowerCase()) || (this.emailRecipientsList.update([...this.emailRecipientsList.value, t]), this.emailTextInput.update("")));
	}
	removeEmailfromEmailRecipientsList = (e) => {
		let t = e.trim();
		t && this.emailRecipientsList.update(this.emailRecipientsList.value.filter((e) => e.toLowerCase() !== t.toLowerCase()));
	};
	setConditionalEmailRules = (e, t = !1) => {
		this.conditionalEmailRules.update(e), t && e?.length && this.conditionalEmailRulesLoaded.update(!0);
	};
}, Ye = class {
	handleExternalMediaHandler = void 0;
	getAssetDetailsFromMediaLibrary = void 0;
	showConditionalLogic = e(!0);
	showEmail = e(!0);
	canAddElements = e(!0);
	hideSubmitButton = e(!1);
	formResponseMode = e("allSubmissions");
	updateConfig = ({ showConditionalLogic: e, showEmail: t, canAddElements: n, hideSubmitButton: r, formResponseMode: i }) => {
		this.showConditionalLogic.update(e), this.showEmail.update(t), this.canAddElements.update(n), this.hideSubmitButton.update(r), this.formResponseMode.update(i);
	};
	setDefaultConfig = () => {
		this.updateConfig({
			showConditionalLogic: !0,
			showEmail: !0,
			canAddElements: !0,
			hideSubmitButton: !1,
			formResponseMode: "allSubmissions"
		});
	};
	setPollConfig = () => {
		this.updateConfig({
			showConditionalLogic: !1,
			showEmail: !1,
			canAddElements: !1,
			hideSubmitButton: !0,
			formResponseMode: "latestPerRespondent"
		});
	};
	initialiseConfig = (e, t) => {
		switch (e) {
			case G.POLL:
				this.setPollConfig();
				break;
			case G.NONE:
			default:
				t ? this.updateConfig(t) : this.setDefaultConfig();
				break;
		}
	};
}, Xe = class {
	elements;
	settings;
	email;
	config;
	constructor() {
		let e = (e) => this.validateForm(e);
		this.elements = new Ke(e), this.settings = new qe(e), this.email = new Je(e), this.config = new Ye();
	}
	get formBuilderData() {
		return this.elements.formBuilderData;
	}
	get showAddNewWidgets() {
		return this.elements.showAddNewWidgets;
	}
	get openEditElementId() {
		return this.elements.openEditElementId;
	}
	get dirtyElements() {
		return this.elements.dirtyElements;
	}
	get formTemplateType() {
		return this.elements.FormTemplate;
	}
	get formSubmitButtonText() {
		return this.settings.formSubmitButtonText;
	}
	get formTitle() {
		return this.settings.formTitle;
	}
	get viewFormButtonText() {
		return this.settings.viewFormButtonText;
	}
	get submitElementIsDirty() {
		return this.settings.submitElementIsDirty;
	}
	get viewFormElementIsDirty() {
		return this.settings.viewFormElementIsDirty;
	}
	get emailResponseEnabled() {
		return this.email.emailResponseEnabled;
	}
	get emailTextInput() {
		return this.email.emailTextInput;
	}
	get emailRecipientsList() {
		return this.email.emailRecipientsList;
	}
	get emailRecipientsListIsDirty() {
		return this.email.emailRecipientsListIsDirty;
	}
	get conditionalEmailRules() {
		return this.email.conditionalEmailRules;
	}
	get conditionalEmailRulesLoaded() {
		return this.email.conditionalEmailRulesLoaded;
	}
	validationMap = e({});
	validateFormElements = (e) => {
		let t = {};
		return this.elements.formBuilderData.value.forEach((n) => {
			let r = Ee(n, e, this);
			r.length === 0 && this.elements.dirtyElements.update(this.elements.dirtyElements.value.filter((e) => n.id !== e)), t[n.id] = r;
		}), t;
	};
	validateSubmitButton = (e) => {
		let t = {};
		if (this.submitElementIsDirty.value || e) {
			let e = this.validateButtonText(this.formSubmitButtonText.value);
			e && (t.submit = e);
		}
		return t;
	};
	validateViewFormTextButton = (e) => {
		let t = {};
		if (this.viewFormElementIsDirty.value || e) {
			let e = this.validateButtonText(this.viewFormButtonText.value);
			e && (t.view = e);
		}
		return t;
	};
	validatePollVoteButtons = ({ validateAllFields: e, validateVoteText: t }) => {
		let n = {};
		return (e || t) && this.elements.formBuilderData.value.filter((e) => e.type === O.POLL || e.type === O.SINGLESELECT).forEach((e) => {
			let t = this.validateButtonText(e.elementSubmitButtonText);
			t && (n[`${e.id}-vote-button`] = t);
		}), n;
	};
	validateEmailRules = (e) => {
		let t = {};
		return this.emailResponseEnabled.value && (this.emailRecipientsListIsDirty.value || e) && this.emailRecipientsList.value.length === 0 && this.conditionalEmailRules.value?.length === 0 && (t.email = [B.AT_LEAST_1_EMAIL_ADDRESS_IS_REQUIRED]), t;
	};
	validateConditionalEmailRules = () => {
		let e = {};
		if (this.conditionalEmailRules.value?.length) for (let t of this.conditionalEmailRules.value) e[t.id] = Te(t.rules, t.id, this), t.emailList.length === 0 && e[t.id].push(B.AT_LEAST_1_EMAIL_ADDRESS_IS_REQUIRED), e[t.id].length === 0 && this.elements.dirtyElements.update(this.elements.dirtyElements.value.filter((e) => t.id !== e));
		return e;
	};
	validateForm = (e) => {
		let t = {
			...this.validateFormElements(e?.validateAllFields),
			...this.validateSubmitButton(e?.validateAllFields),
			...this.validateViewFormTextButton(e?.validateAllFields),
			...this.validateEmailRules(e?.validateAllFields),
			...this.validateConditionalEmailRules(),
			...this.validatePollVoteButtons({
				validateAllFields: !!e?.validateAllFields,
				validateVoteText: !!e?.validateVoteText
			})
		};
		this.validationMap.update(t);
	};
	validateButtonText(e) {
		if (e.trim().length === 0) return B.TITLE_IS_REQUIRED;
		if (e.length > 20) return B.MAX_LENGTH_20;
	}
	checkFormIsValidAndCleanAllElementsBeforeSubmit = () => (this.validateForm({ validateAllFields: !0 }), !(Object.values(this.validationMap.value).flatMap((e) => e).length >= 1));
}, Ze = new Xe();
//#endregion
//#region src/service/models/condition.model.ts
function Qe(e, t, n, r, i) {
	return { toggleConditions: e.map((e) => {
		let a = t.find((t) => Number(t.value) === Number(e.condition?.value));
		return {
			ariaLabel: "Select Option",
			buttonList: t.map((t) => ({
				id: t.value,
				isDisabled: !1,
				label: t.label,
				onButtonClick: () => {
					r(e, String(t.value));
				},
				text: t.label
			})),
			className: "",
			defaultTitle: "Select a Field",
			label: "",
			selectedItem: n ? {
				id: a?.value,
				isDisabled: !1,
				label: a?.label,
				onButtonClick: () => {
					r(e, "");
				},
				text: a?.label
			} : {},
			toggleDisabled: !1,
			id: e.id,
			removeOption: () => {
				i.removeRules(String(e.id));
			}
		};
	}) };
}
function $e(e, t, n, r = !1, i, a) {
	n = r ? n : c();
	let o = n[0], s = n[n.length - 1];
	function c() {
		return P(t.rules.value[e.id], t.rules.value).map((e) => t.rules.value[e]);
	}
	let l = (e, r) => {
		let i = r.elements.getElement(e);
		for (let r of n) t.addRules(String(r.id), {
			...r,
			condition: {
				...r.condition,
				elementId: e,
				conditionValueType: ue(i?.type)
			}
		});
	}, u = (e) => {
		if (e === "isEmpty" || e === "isNotEmpty" || e === "isChecked" || e === "isNotChecked") {
			let r = n[0];
			for (let i of n) i.id === r.id ? t.addRules(String(i.id), {
				...i,
				condition: {
					...i.condition,
					conditionMetaType: e,
					...pe(e)
				}
			}) : t.removeRules(String(i.id));
		} else for (let r of n) t.addRules(String(r.id), {
			...r,
			condition: {
				...r.condition,
				conditionType: e,
				conditionMetaType: e
			}
		});
	}, d = (e, n) => {
		t.addRules(String(e.id), {
			...e,
			condition: {
				...e.condition,
				value: n
			}
		});
	};
	return {
		addToggleOption: () => t.splitNodeIntoLeafs(A.OR, s.id),
		id: N(),
		conditionOne: {
			ariaLabel: "Select a field",
			buttonList: i.elements.getElementsBeforeId(a).map((e) => ({
				id: e.id,
				isDisabled: !1,
				label: e.title,
				onButtonClick: () => {
					l(e.id, i);
				},
				text: e.title
			})),
			className: "",
			defaultTitle: "Select a Field",
			label: t?.conditionOneLabel || "FIELD",
			selectedItem: o?.condition?.elementId ? {
				id: o?.condition?.elementId,
				isDisabled: i.elements.getElementsBeforeId(a).length === 0,
				label: i.elements.getElement(o?.condition?.elementId)?.title,
				onButtonClick: () => l(-1, i),
				text: i.elements.getElement(o?.condition?.elementId)?.title
			} : null,
			toggleDisabled: i.elements.getElementsBeforeId(a).length === 0
		},
		conditionTwo: {
			ariaLabel: "Select a condition",
			buttonList: ((e) => {
				let t = e.elements.getElement(Number(n?.[0].condition?.elementId)), r = [
					O.DROPDOWN,
					O.TEXTAREA,
					O.TEXTENTRY,
					O.SINGLEOPTION
				].includes(t?.type), i = [];
				return i = t?.type === O.CHECKBOX ? ["isChecked", "isNotChecked"] : ["isEmpty", "isNotEmpty"], r && (i = [j.EQUAL, ...i]), i.map((e) => Be(e, () => u(e)));
			})(i),
			className: "",
			defaultTitle: "",
			label: "IS",
			selectedItem: Be(o?.condition?.conditionMetaType, () => u("")),
			toggleDisabled: i.elements.getElementsBeforeId(a).length === 0
		},
		...(() => {
			let e = n[0], r = i.elements.getElement(Number(e.condition?.elementId)), a = r?.type;
			if ([
				"isEmpty",
				"isNotEmpty",
				""
			].includes(e?.condition?.conditionMetaType)) return {};
			if (a === O.SINGLEOPTION) {
				let i = r?.options || [], a = i.find((t) => Number(t.value) === Number(e.condition?.value));
				return Qe(n, i, a, d, t);
			}
			if (a === O.DROPDOWN) {
				let i = r.optionSets.flatMap((e, t) => e.options.map((e) => ({
					...e,
					optionSet: r.optionSets.length > 1 ? `Option Set ${t}` : null
				}))), a = i.find((t) => Number(t.value) === Number(e.condition?.value));
				return Qe(n, i, a, d, t);
			}
			return a === O.TEXTAREA || a === O.TEXTENTRY ? { textConditions: n.map((e) => ({
				id: String(e.id),
				ariaLabel: "Text Value",
				className: "",
				isDisabled: !1,
				label: "VALUE",
				setTextInput: (t) => d(e, t),
				text: e.condition?.value,
				updateOnBlur: !0,
				removeOption: () => {
					t.removeRules(String(e.id));
				}
			})) } : {};
		})()
	};
}
//#endregion
//#region src/service/models/rulesManager.model.ts
var K = class {
	parentElementId;
	rules = e({});
	showAddNewRule = e(!1);
	newRuleType = e(M.SHOW);
	noOfRules = e(0);
	isOrTree = e(!1);
	combinator = e(A.AND);
	conditionOneLabel = "FIELD";
	constructor(e) {
		e?.rules && this.rules.update(e.rules), e?.newRuleType && this.newRuleType.update(e.newRuleType), e?.conditionalLabelOne && (this.conditionOneLabel = e?.conditionalLabelOne), this.parentElementId = e?.parentElementId, this.rules.subscribe((e) => {
			let t = F(e[0], e);
			this.isOrTree.update(t), t ? this.combinator.update(A.OR) : this.combinator.update(A.AND), this.noOfRules.update(Object.keys(this.rules.value).length);
		});
	}
	addRules = (e, t) => {
		this.rules.update({
			...this.rules.value,
			[e]: t
		});
	};
	setShowAddNewRule = (e) => {
		this.showAddNewRule.update(e);
	};
	setRuleType = (e) => {
		this.newRuleType.update(e);
	};
	buildRules = () => {
		let e = (t) => (typeof t?.expression1 == "number" && (t.expression1 = { ...this.rules.value[t?.expression1] }, e(t.expression1)), typeof t?.expression2 == "number" && (t.expression2 = { ...this.rules.value[t?.expression2] }, e(t.expression2)), t?.condition && t?.expression1 && t?.expression2 && (t.condition = void 0), t);
		return {
			ruleType: this.newRuleType.value,
			expression: this.rules.value[0] ? e({ ...this.rules.value[0] }) : null
		};
	};
	removeRules = (e) => {
		if (Object.keys(this.rules.value).length <= 1) {
			this.rules.update({}), this.showAddNewRule.update(!1);
			return;
		}
		let t = this.rules.value[e];
		if (!t?.expression1 && !t?.expression2) {
			let t = ge(this.rules.value, Number(e));
			if (t) {
				let n = t.expression1 === Number(e), r = { ...this.rules.value[n ? t.expression2 : t.expression1] };
				this.addRules(String(t.id), {
					...r,
					id: t.id
				});
				let i = { ...this.rules.value };
				delete i[e], delete i[r.id], this.rules.update(i);
			} else if (!t) {
				let t = { ...this.rules.value };
				delete t[e], this.rules.update(t);
			}
		}
	};
	importRules = (e, t) => {
		if (!e) return;
		let n = L(e, {}, t);
		this.rules.update(n);
	};
	addNodeToRoot = (e) => {
		let t = {
			...this.rules.value[0],
			id: N()
		}, n = {
			...fe,
			id: N()
		}, r = {
			id: 0,
			expression1: t.id,
			expression2: n.id,
			condition: void 0,
			combinator: e
		}, i = {
			...this.rules.value,
			[n.id]: n,
			[t.id]: t
		};
		i[0] = r, this.rules.update(i);
	};
	splitNodeIntoLeafs = (e, t) => {
		let n = {
			...this.rules.value[t],
			id: N()
		}, r = {
			...this.rules.value[t],
			condition: {
				...this.rules.value[t].condition,
				value: ""
			},
			id: N()
		}, i = {
			id: t,
			expression1: n.id,
			expression2: r.id,
			condition: void 0,
			combinator: e
		}, a = {
			...this.rules.value,
			[n.id]: n,
			[r.id]: r
		};
		a[t] = i, this.rules.update(a);
	};
	getRuleExpressionsForUIMapping = (e) => {
		let t = Object.values(this.rules.value);
		if (t.length === 0) return this.addRules("0", fe), [];
		if (t.length >= 1) if (this.isOrTree.value) {
			let t = this.rules.value;
			return me(t).map((n) => {
				let r = n.map((e) => t[e.id]);
				return $e(n[0], this, r, !0, e, this.parentElementId);
			});
		} else {
			let t = this.rules.value;
			return I(t[0], [], t).map((n) => $e(t[n], this, [], !1, e, this.parentElementId));
		}
		return [];
	};
	setCombinator(e) {
		if (this.combinator.update(e), this.isOrTree.update(!0), e === A.OR) {
			this.isOrTree.update(!0);
			let e = { ...this.rules.value };
			for (let t of Object.values(e)) t.combinator === A.AND && (e[t.id] = {
				...e[t.id],
				combinator: A.OR
			});
			this.rules.update(e);
		} else {
			this.isOrTree.update(!1);
			let e = this.rules.value, t = me(e);
			this.rules.update(ye(t, A.AND));
		}
	}
	removeCondition(e, t) {
		t ||= "";
		let n = P(this.rules.value[0], this.rules.value).map((e) => this.rules.value[e]).filter((n) => !(n.condition?.conditionMetaType === t && n.condition?.elementId === e));
		this.rules.update(ye(he(n), this.combinator.value));
	}
	areRulesInValid(e, t) {
		let n = e[this.parentElementId] || [], r = Se(Object.values(this.rules.value)), i = xe(this.parentElementId, Object.values(this.rules.value), t), a = n.includes(B.RULES_ARE_INCOMPLETE) && r, o = n.includes(B.CONDITIONAL_EXPRESSION_IS_INCOMPLETE) && r;
		return i || a || o;
	}
}, et = class {
	FBService;
	emailConditions = e([]);
	emailConditionsChanged = e(!1);
	isInitialsised = !1;
	constructor(e) {
		this.FBService = e;
	}
	initialiseConditionalEmail = () => {
		if (this.isInitialsised = !0, this.FBService.conditionalEmailRules.value.length) {
			let e = [];
			for (let t of this.FBService.conditionalEmailRules.value) {
				let n = new K({
					parentElementId: t.id,
					newRuleType: M.SENDWHEN,
					conditionalLabelOne: "SEND WHEN"
				});
				n.importRules(t.rules.expression, this.FBService), e.push({
					id: t.id,
					emailList: t.emailList,
					rules: n,
					inputString: ""
				}), n.rules.subscribe(() => {
					this.handleRulesObjectHasChangedSubscription();
				});
			}
			this.emailConditions.update(e);
		}
	};
	addCondition = (e) => {
		let t = N(), n = new K({
			rules: e?.rules || void 0,
			parentElementId: t,
			newRuleType: M.SENDWHEN,
			conditionalLabelOne: "SEND WHEN"
		}), r = {
			id: t,
			emailList: e?.emailList || [],
			rules: n,
			inputString: ""
		};
		n.rules.subscribe(() => {
			this.handleRulesObjectHasChangedSubscription();
		}), this.emailConditions.update([...this.emailConditions.value, r]);
	};
	removeCondition = (e) => {
		(this?.emailConditions?.value?.find((t) => t.id === e))?.rules.rules.unsubscribe(this.handleRulesObjectHasChangedSubscription);
		let t = this?.emailConditions?.value.filter((t) => t.id !== e);
		this.emailConditions.update(t), this.emailConditionsChanged.update(!0);
	};
	removeAllConditions = () => {
		this.emailConditions.value.forEach((e) => {
			this.removeCondition(e.id);
		});
	};
	handleRulesObjectHasChangedSubscription = () => this.emailConditionsChanged.update(!0);
	getInputStringAtId = (e) => this.emailConditions.value.find((t) => t.id === e)?.inputString;
	setInputStringAtId = (e, t) => {
		let n = this.emailConditions.value.map((n) => n.id === e ? {
			...n,
			inputString: t
		} : n);
		this.emailConditions.update(n);
	};
	containsValidationErrors = (e) => {
		let t = new Set(Array.from(Object.keys(e))), n = new Set(this.emailConditions.value.map((e) => String(e.id))), r = new Set(Array.from(t).filter((e) => n.has(e)));
		return Array.from(r).flatMap((t) => e[t]).length > 0;
	};
	setEmailListAtId = (e) => {
		let t = this.emailConditions.value.map((t) => t.id === e ? {
			...t,
			inputString: "",
			emailList: [...t.emailList, t.inputString]
		} : t);
		this.emailConditions.update(t), this.emailConditionsChanged.update(!0);
	};
	removeEmailListAtId = (e, t) => {
		let n = t.trim();
		if (!n) return;
		let r = this.emailConditions.value.map((t) => t.id === e ? {
			...t,
			inputString: "",
			emailList: t.emailList.filter((e) => e.toLowerCase() !== n.toLowerCase())
		} : t);
		this.emailConditions.update(r), this.emailConditionsChanged.update(!0);
	};
	getFormattedRules = () => this?.emailConditions?.value?.map((e) => ({
		id: e.id,
		rules: e.rules.buildRules(),
		emailList: e.emailList
	}));
	resolveEmailConditionsChanged = () => {
		this.emailConditionsChanged.update(!1);
	};
	clearAllSubscriptions = () => {
		this?.emailConditions?.value?.forEach((e) => {
			e.rules?.rules?.unsubscribe?.(this.handleRulesObjectHasChangedSubscription);
		});
	};
	elementContainsLogicErrorts = (e, t) => e[t]?.length ? !(e[t]?.length === 1 && e[t].includes(B.AT_LEAST_1_EMAIL_ADDRESS_IS_REQUIRED)) : !1;
	elementHasMissingEmailConditionsError = (e, t) => !!(e[t]?.length && e[t].includes(B.AT_LEAST_1_EMAIL_ADDRESS_IS_REQUIRED));
}, tt = n(Ze), nt = ({ service: e, children: t }) => /* @__PURE__ */ T(tt.Provider, {
	value: e,
	children: t
}), q = () => r(tt), rt = ({ rm: e, title: n, hideFirstLabel: r, isConditionalEmail: a }) => {
	let o = q(), [c, l] = s([]), [u, d] = s(null), f = t(e.isOrTree), m = t(e.rules), h = t(o.formBuilderData), g = o.elements.getElementsBeforeId(e.parentElementId).length > 0, v = t(e.combinator), ee = t(o.formBuilderData), y = t(o.validationMap);
	i(() => {
		l(e.getRuleExpressionsForUIMapping(o));
	}, [
		m,
		f,
		ee
	]);
	function b() {
		e.removeCondition(u?.conditionOne?.selectedItem?.id, u?.conditionTwo?.selectedItem?.contentMetaType), d(null);
	}
	let te = r ? c.map((e, t) => t === 0 ? {
		...e,
		conditionOne: {
			...e.conditionOne,
			label: n ?? e.conditionOne.label
		}
	} : e) : c;
	return /* @__PURE__ */ E(w, { children: [
		/* @__PURE__ */ T(it, {
			rm: e,
			hasElementsAfter: g,
			validationErrors: y[e.parentElementId] || [],
			isDropDownConditionalExpression: r,
			isConditionalEmail: a
		}),
		h.length >= 1 && /* @__PURE__ */ T(_, {
			onAddConditionClick: g ? () => e.addNodeToRoot(v) : void 0,
			onRemoveConditionClick: (e) => {
				d(e);
			},
			panelClassName: `dropdown-element-condition-panel ${e.areRulesInValid(y, o) ? "form-error" : ""}`,
			removeConditionButtonLabel: "Remove Condition",
			title: r ? void 0 : n,
			toggleItems: te.map((e) => e),
			combinator: v,
			setCombinator: (t) => e.setCombinator(t)
		}),
		u && /* @__PURE__ */ T(p, {
			headerText: "Delete conditional check?",
			questionText: "Are you sure you want to delete this conditional value check?",
			onCloseClick: () => d(null),
			onConfirmClick: () => {
				b();
			}
		})
	] });
}, it = ({ rm: e, hasElementsAfter: t, validationErrors: n, isDropDownConditionalExpression: r, isConditionalEmail: i }) => {
	let a = q(), o = xe(e.parentElementId, Object.values(e.rules.value), a);
	return n.includes(B.RULES_ARE_INCOMPLETE) && !r ? i ? /* @__PURE__ */ T(C, {
		type: "error",
		children: /* @__PURE__ */ T("span", { children: "This email condition contains incomplete rules. Please complete each rule, or delete the condition if it’s not needed." })
	}) : /* @__PURE__ */ T(C, {
		type: "error",
		children: t ? /* @__PURE__ */ T("span", { children: "This field has incomplete conditional rules. Please complete each rule, or turn off conditional logic if it’s not needed." }) : /* @__PURE__ */ T("span", { children: "There are no fields above this to match any conditions on. Please either move this field or turn off conditional logic if it’s not needed." })
	}) : o ? /* @__PURE__ */ T(C, {
		type: "error",
		children: /* @__PURE__ */ T("span", { children: "This depends on another field that was moved below or deleted. Move that field above, or change this field’s settings." })
	}) : t ? /* @__PURE__ */ T(w, {}) : /* @__PURE__ */ T(C, {
		type: "info",
		children: /* @__PURE__ */ T("span", { children: "There are no fields above this to match any conditions on." })
	});
}, J = (e, t) => {
	i(() => {
		let n = (n) => {
			n.relatedTarget && (e?.current?.contains(n.relatedTarget) || t(!0));
		};
		return e.current?.addEventListener("focusout", n), () => {
			e.current?.removeEventListener("focusout", n);
		};
	}, []);
}, at = ({ conditionalEmailRule: e, CEModel: t, validationMap: n }) => {
	let r = q(), i = o(null);
	return J(i, () => r.elements.addDirtyElement([e.id])), /* @__PURE__ */ T("div", {
		id: String(e.id),
		ref: i,
		children: /* @__PURE__ */ E(g, {
			className: t.elementContainsLogicErrorts(n, e.id) ? "error" : "",
			title: "EMAIL LIST",
			emailTextInput: t.getInputStringAtId(e.id),
			setEmailTextInput: (n) => t.setInputStringAtId(e.id, n),
			handleAddEmailClick: () => t.setEmailListAtId(e.id),
			emailRecipientsList: e.emailList,
			removeEmailFromList: (n) => t.removeEmailListAtId(e.id, n),
			children: [
				/* @__PURE__ */ T(rt, {
					title: "",
					rm: e.rules,
					hideFirstLabel: !1,
					isConditionalEmail: !0
				}),
				/* @__PURE__ */ T("hr", { className: "conditional-email-spacer" }),
				t.elementHasMissingEmailConditionsError(n, e.id) && /* @__PURE__ */ T(C, {
					className: "email-error-container",
					type: "error",
					children: /* @__PURE__ */ T("span", { children: "At least 1 email address is required when 'Send responses by email' is enabled" })
				}),
				/* @__PURE__ */ T(d, {
					className: "remove-rule-button",
					content: /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T(ie, {
						iconName: S.BIN,
						color: "#067bbe",
						sizeInPx: "13"
					}), /* @__PURE__ */ T("span", {
						className: "remove-rule-text",
						children: "Remove Rule"
					})] }),
					ariaLabel: "Remove Rule",
					onButtonClick: () => t.removeCondition(e.id)
				})
			]
		}, `email-rule-${e.id}`)
	});
}, ot = ({ show: e }) => {
	let n = q(), [r] = s(new et(n)), a = t(n.emailTextInput), o = t(n.emailRecipientsList), c = t(r.emailConditions), l = t(r.emailConditionsChanged), u = t(n.validationMap), d = t(n.conditionalEmailRulesLoaded), f = t(n.emailResponseEnabled);
	return i(() => () => {
		r.clearAllSubscriptions();
	}, []), i(() => {
		d && r.initialiseConditionalEmail();
	}, [d]), i(() => {
		l && (n.email.setConditionalEmailRules(r.getFormattedRules()), r.resolveEmailConditionsChanged()), r.containsValidationErrors(u) && n.validateForm();
	}, [l, r.containsValidationErrors(u)]), i(() => {
		f || r.removeAllConditions();
	}, [f]), e ? /* @__PURE__ */ E(w, { children: [
		/* @__PURE__ */ T(g, {
			title: "DEFAULT LIST",
			emailTextInput: a,
			setEmailTextInput: n.email.setEmailTextInput,
			handleAddEmailClick: () => n.email.addEmailToEmailRecipientsList(a),
			emailRecipientsList: o,
			removeEmailFromList: n.email.removeEmailfromEmailRecipientsList
		}),
		c.map((e) => /* @__PURE__ */ T(at, {
			conditionalEmailRule: e,
			CEModel: r,
			validationMap: u
		}, e.id)),
		/* @__PURE__ */ T(te, {
			onClick: () => r.addCondition(),
			text: /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T("span", {
				className: "add-email-condition-icon",
				children: "+"
			}), "Add Conditional Email Rule"] }),
			label: "Add Conditional Email Rule"
		})
	] }) : /* @__PURE__ */ T(w, {});
}, st = () => {
	let e = q(), n = t(e.emailResponseEnabled), r = t(e.emailRecipientsList), a = o(null), s = t(e.validationMap);
	return i(() => {
		e.validateForm();
	}, [
		n,
		r,
		t(e.emailRecipientsListIsDirty)
	]), J(a, e.email.setEmailRecipientsListIsDirty), /* @__PURE__ */ E("div", {
		className: "form-builder-settings",
		ref: a,
		children: [
			/* @__PURE__ */ T("h3", {
				className: "form-settings-header",
				children: "Form Settings"
			}),
			s.email?.includes(B.AT_LEAST_1_EMAIL_ADDRESS_IS_REQUIRED) && /* @__PURE__ */ T(C, {
				className: "email-error-container",
				type: "error",
				children: /* @__PURE__ */ T("span", { children: "At least 1 email address is required when 'Send responses by email' is enabled" })
			}),
			/* @__PURE__ */ T(f, {
				id: "email-setting-checkbox",
				isChecked: n,
				onChange: () => e.email.setEmailResponseEnabled(!n),
				label: "Send responses by email",
				ariaLabel: "Send responses by email"
			}),
			/* @__PURE__ */ E("div", {
				className: "email-setting-additional-info",
				children: [
					"Responses and attachments are secure by default. Enabling this will email them to the addresses you add below, and attachments like images or files will be shared using ",
					/* @__PURE__ */ T("span", {
						className: "boldened-text",
						children: "public links"
					}),
					". Anyone with the link can view them."
				]
			}),
			/* @__PURE__ */ T(ot, { show: n })
		]
	});
}, ct = class extends V {
	options = e([]);
	defaultValue = e(0);
	constructor(e, t) {
		super(e, t), e.options.length && this.options.update(e.options), this.options.update(e.options), this.defaultValue.update(e.defaultValue);
	}
	addNewOption = () => {
		this.options.update([...this.options.value, {
			id: N(),
			label: "",
			value: N()
		}]);
	};
	updateOption = (e, t) => {
		let n = this.options.value.map((n) => n.id === e ? {
			...n,
			label: t
		} : n);
		this.options.update(n);
	};
	updateDefaultValue = (e) => {
		this.defaultValue.update(e);
	};
	formatToFormData = () => ({
		type: this.type,
		defaultValue: this.defaultValue.value,
		id: this.id,
		options: this.options.value,
		title: this.title.value,
		validation: this.getValidation(),
		rules: this.formatRules()
	});
	addToForm = () => {
		this.FBService.elements.addNewSingleOption(this.formatToFormData()), this.FBService.elements.setShowAddNewWidgets(!1);
	};
	updateForm = () => {
		this.FBService.elements.updateElement(this.id, this.formatToFormData());
	};
	getPlaceholderString = (e) => this.options.value[0].id === e ? "First Option" : "Second Option";
}, Y = class extends V {
	placeholder = e("");
	defaultValue = e("");
	validationErrors = e([]);
	constructor(e, t) {
		super(e, t), this.placeholder.update(e.placeholder), this.defaultValue.update(e.defaultValue);
	}
	setPlaceholder = (e) => {
		this.placeholder.update(e);
	};
	getTitleStringsForInputType() {
		switch (this.type) {
			case O.TEXTAREA: return "Long Text";
			case O.TEXTENTRY: return "Short Text";
			case O.ORGUSERSEARCH: return "User Select";
		}
	}
	formatToFormData = () => ({
		type: this.type,
		placeholder: this.placeholder.value,
		defaultValue: this.defaultValue.value,
		id: this.id,
		title: this.title.value,
		validation: this.getValidation(),
		rules: this.formatRules()
	});
	addToForm = () => {
		this.FBService.elements.addNewText(this.formatToFormData()), this.FBService.elements.setShowAddNewWidgets(!1);
	};
	updateForm = () => {
		let e = this.formatToFormData();
		this.FBService.elements.updateElement(this.id, e);
	};
	getInputTypeForUI = () => {
		switch (this.type) {
			case O.TEXTAREA: return "Long Text";
			case O.TEXTENTRY: return "Short Text";
			case O.ORGUSERSEARCH: return "User Select";
		}
	};
	getElementJSON() {
		return JSON.stringify(this.formatToFormData());
	}
	removeValidationErrors = (e) => {
		let t = this.validationErrors.value.filter((t) => t !== e);
		this.validationErrors.update(t);
	};
}, lt = class extends V {
	defaultValue = e("");
	constructor(e, t) {
		super(e, t), this.defaultValue.update(e.defaultValue), Ee(e, !1, t);
	}
	formatToFormData() {
		return {
			type: this.type,
			placeholder: "",
			defaultValue: this.defaultValue.value,
			id: this.id,
			title: this.title.value,
			validation: this.getValidation(),
			rules: this.formatRules()
		};
	}
	addToForm = () => {
		this.FBService.elements.addNewText(this.formatToFormData()), this.FBService.elements.setShowAddNewWidgets(!1);
	};
	updateForm = () => {
		let e = this.formatToFormData();
		this.FBService.elements.updateElement(this.id, e);
	};
}, X = class extends V {
	allowCaption = e(!1);
	captionTitleText = e("");
	captionPlaceholder = e("");
	maxImages = e(10);
	buttonText = e("");
	showAdvancedOptions = e(!1);
	constructor(e, t) {
		super(e, t), this.maxImages.update(e.maxFileCount), this.buttonText.update(e.buttonText), e.type === O.PHOTOS && (this.allowCaption.update(e.caption.enabled), this.captionTitleText.update(e.caption.title || ""), this.captionPlaceholder.update(e.caption.placeholder || ""));
	}
	setButtonText = (e) => {
		this.buttonText.update(e);
	};
	setAllowCaption = (e) => {
		this.allowCaption.update(e);
	};
	setCaptionTitle = (e) => {
		this.captionTitleText.update(e);
	};
	setCaptionPlaceholder = (e) => {
		this.captionPlaceholder.update(e);
	};
	setShowAdvanced = (e) => {
		this.showAdvancedOptions.update(e);
	};
	setMaxImages = (e) => {
		this.maxImages.update(e);
	};
	getAllowedTypes = () => ({
		fileValidationTypes: se(this.type),
		fileValidationMessage: ce(this.type)
	});
	getWidgetTitle = () => {
		switch (this.type) {
			case O.PHOTOS: return "Image";
			case O.VIDEOS: return "Video";
			case O.FILES: return "Video";
			default: return "";
		}
	};
	getElementTypeForUI = () => {
		switch (this.type) {
			case O.PHOTOS: return "Image Select";
			case O.VIDEOS: return "Video Select";
			case O.FILES: return "File Select";
			default: return "";
		}
	};
	formatToFormData = () => {
		let { fileValidationTypes: e, fileValidationMessage: t } = this.getAllowedTypes(), n = {
			type: this.type,
			maxFileCount: this.maxImages.value,
			buttonText: this.title.value,
			id: this.id,
			title: this.title.value,
			validation: [
				{
					validationType: D.MAXFILESIZE,
					errorMessage: "File size too large. Please upload a file no larger than 1 GiB",
					value: 1073741824
				},
				{
					validationType: D.ACCEPTEDFILETYPE,
					errorMessage: t,
					value: e
				},
				...this.getValidation()
			],
			rules: this.formatRules()
		};
		return this.type === O.PHOTOS && (n = {
			...n,
			caption: {
				enabled: this.allowCaption.value,
				title: this.captionTitleText.value,
				placeholder: this.captionPlaceholder.value
			}
		}), n;
	};
	addToForm = () => {
		this.FBService.elements.addNewImage(this.formatToFormData());
	};
	updateForm = () => {
		let e = this.formatToFormData();
		this.FBService.elements.updateElement(this.id, e);
	};
}, ut = ({ containerRef: e }) => {
	let n = q();
	return /* @__PURE__ */ T(y, {
		onCheckboxClick: () => new lt(ze(), n).addToForm(),
		onDropdownClick: () => new H(Fe(), n).addToForm(),
		onSingleSelectClick: () => new W(Ie(), n).addToForm(),
		onFileSelectClick: () => new X(Pe(), n).addToForm(),
		onImageSelectClick: () => new X(Me(), n).addToForm(),
		onLongTextClick: () => new Y(je(), n).addToForm(),
		onShortTextClick: () => new Y(Ae(), n).addToForm(),
		onUserSelectClick: () => new Y(Le(), n).addToForm(),
		onVideoSelectClick: () => new X(Ne(), n).addToForm(),
		onChoiceButtonClick: () => new ct(Re(), n).addToForm(),
		isOpen: t(n.showAddNewWidgets),
		handleClose: () => n.elements.setShowAddNewWidgets(!1),
		containerRef: e
	});
}, dt = () => {
	let e = q(), n = t(e.showAddNewWidgets), r = o(null);
	return /* @__PURE__ */ E("div", {
		ref: r,
		children: [/* @__PURE__ */ T(c, {
			ariaLabel: "Add Form Option",
			onButtonClick: () => {
				e.elements.setShowAddNewWidgets(!0);
			},
			text: "Add Form Option",
			hideButton: n
		}), n && /* @__PURE__ */ T(ut, { containerRef: r })]
	});
}, ft = ({ parentRules: e, parent: n, ruleType: r, title: a, hideFirstLabel: o }) => {
	let c = q(), [l] = s(new K({
		newRuleType: r,
		parentElementId: n.id
	})), u = t(l.rules);
	return t(c.formBuilderData), i(() => {
		l.importRules(e, c);
	}, []), i(() => {
		n.addRules(l.buildRules());
	}, [u]), /* @__PURE__ */ T(rt, {
		title: a,
		rm: l,
		hideFirstLabel: o
	});
}, Z = ({ model: e }) => {
	let n = q(), r = t(e.conditionalRule), i = t(n.config.showConditionalLogic);
	return /* @__PURE__ */ T("div", {
		className: "rules-container",
		children: r && i && /* @__PURE__ */ T(ft, {
			parent: e,
			ruleType: M.SHOW,
			title: "SHOW FORM FIELD WHEN",
			parentRules: e.rules.value[M.SHOW]?.expression
		})
	});
}, Q = ({ model: e }) => {
	let n = q(), r = t(e.isRequired), i = t(e.conditionalRule), a = t(n.config.showConditionalLogic);
	return a ? /* @__PURE__ */ T(h, {
		formElementId: e.id,
		isRequiredElement: r,
		setIsRequiredElement: () => e.setIsRequired(!r),
		conditionalRuleEnabled: i && a,
		setConditionalRuleEnabled: () => e.setConditionalRule(!i)
	}) : /* @__PURE__ */ T(w, {});
}, $ = ({ model: e, observables: t }) => {
	i(() => {
		e.updateForm();
	}, [...t]);
}, pt = ({ model: e, index: n }) => {
	let r = q(), i = t(e.title), a = t(e.isRequired), o = t(e.options), s = t(e.rules), c = t(r.openEditElementId).includes(e.id), l = t(r.validationMap);
	return $({
		model: e,
		observables: [
			a,
			i,
			s,
			o
		]
	}), /* @__PURE__ */ T("div", {
		className: "form-element-widget-wrapper text-entry-wrapper",
		children: /* @__PURE__ */ T(b, {
			index: n,
			formElementId: e.id,
			elementType: "Choice Button",
			labelText: i,
			setLabelText: (t) => e.setTitle(t),
			onDeleteElementClick: () => r.elements.deleteElement(e.id),
			onDragElementClick: (e, t) => r.elements.handleDragAndDrop(e, t),
			formElementComponent: /* @__PURE__ */ T(mt, {
				elementIndex: n,
				model: e,
				validationErrors: l[e.id] ?? []
			}),
			isFirstElement: r.elements.isFirstElement(e.id),
			isLastElement: r.elements.isLastElement(e.id),
			onMoveElementUp: () => r.elements.moveUp(e.id),
			onMoveElementDown: () => r.elements.moveDown(e.id),
			isRequiredElement: a,
			isEditModeOpen: c,
			setIsEditModeOpen: () => r.elements.setEditMode(e.id),
			rulesComponent: /* @__PURE__ */ T(Z, { model: e }),
			onSaveClick: () => r.elements.setEditMode(e.id),
			conditionalCheckboxPanel: /* @__PURE__ */ T(Q, { model: e }),
			validationErrors: l[e.id]
		})
	});
}, mt = ({ elementIndex: e, model: n, validationErrors: r }) => {
	let i = t(n.options), a = r.includes(B.OPTIONS_MUST_HAVE_LABEL_TEXT);
	function o(e) {
		return a && !e.trim() || e.length >= 513;
	}
	return /* @__PURE__ */ T("ul", {
		className: "choice-element-option-list",
		children: i.map((t, r) => /* @__PURE__ */ E("li", {
			className: "choice-list-item",
			children: [
				/* @__PURE__ */ T(m, {
					id: `choice-element-${e}-${r}`,
					className: `form-element-label-input ${o(t.label.trim()) ? "form-builder-error" : ""}`,
					labelText: `Option ${r + 1}`,
					placeholderText: n.getPlaceholderString(Number(t.id)),
					textString: t.label,
					maxLength: 21,
					setTextString: (e) => n.updateOption(Number(t.id), e)
				}),
				a && !t.label.trim() && /* @__PURE__ */ T("span", {
					className: "error-text",
					children: "Choice label text is required"
				}),
				t.label.length >= 21 && /* @__PURE__ */ T("span", {
					className: "error-text",
					children: "Please enter a maximum of 20 characters"
				})
			]
		}, t.id))
	});
}, ht = ({ children: e = /* @__PURE__ */ T(w, {}), defaultShowAndHideLogic: t = !1 }) => /* @__PURE__ */ T(u, {
	defaultAdvancedSettings: t,
	children: e
}), gt = ({ model: e, index: n }) => {
	let r = q(), i = t(e.isRequired), a = t(e.title), o = t(e.placeholder), s = t(e.rules), c = t(r.validationMap), l = t(r.openEditElementId).includes(e.id);
	return $({
		model: e,
		observables: [
			i,
			a,
			s,
			o
		]
	}), /* @__PURE__ */ T("div", {
		className: "form-element-widget-wrapper text-entry-wrapper",
		children: /* @__PURE__ */ T(b, {
			formElementId: e.id,
			index: n,
			elementType: e.getInputTypeForUI(),
			labelText: a,
			setLabelText: (t) => e.setTitle(t),
			onDeleteElementClick: () => r.elements.deleteElement(e.id),
			onDragElementClick: (e, t) => r.elements.handleDragAndDrop(e, t),
			formElementComponent: /* @__PURE__ */ T(w, {}),
			isFirstElement: r.elements.isFirstElement(e.id),
			isLastElement: r.elements.isLastElement(e.id),
			onMoveElementUp: () => r.elements.moveUp(e.id),
			onMoveElementDown: () => r.elements.moveDown(e.id),
			isRequiredElement: i,
			isEditModeOpen: l,
			setIsEditModeOpen: () => r.elements.setEditMode(e.id),
			rulesComponent: /* @__PURE__ */ T(Z, { model: e }),
			onSaveClick: () => r.elements.setEditMode(e.id),
			conditionalCheckboxPanel: /* @__PURE__ */ T(Q, { model: e }),
			advancedOptions: /* @__PURE__ */ T(_t, {
				index: n,
				model: e
			}),
			validationErrors: c[e.id]
		})
	});
}, _t = ({ index: e, model: n }) => {
	let r = t(n.placeholder);
	function i(e) {
		return e.length >= 513;
	}
	let a = ke(n.type);
	return /* @__PURE__ */ T(ht, {
		defaultShowAndHideLogic: !!r,
		children: /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T(m, {
			id: `text-element=${e}`,
			className: `form-element-label-input ${i(r) ? "form-builder-error" : ""}`,
			labelText: "Placeholder Text",
			placeholderText: "Add Placeholder",
			textString: r,
			maxLength: a + 1,
			setTextString: (e) => n.setPlaceholder(e)
		}), r.length > a && /* @__PURE__ */ E("span", {
			className: "error-text",
			children: [
				"Please enter a maximum of ",
				a,
				" characters"
			]
		})] })
	});
}, vt = ({ model: e, index: n }) => {
	let r = q(), i = t(e.title), a = t(e.isRequired), o = t(e.rules), s = t(e.maxImages), c = t(e.buttonText), l = t(e.allowCaption), u = t(r.openEditElementId).includes(e.id), d = t(r.validationMap);
	return $({
		model: e,
		observables: [
			a,
			i,
			o,
			s,
			c,
			l
		]
	}), /* @__PURE__ */ T("div", {
		className: "form-element-widget-wrapper text-entry-wrapper",
		children: /* @__PURE__ */ T(b, {
			index: n,
			formElementId: e.id,
			elementType: e.getElementTypeForUI(),
			labelText: i,
			setLabelText: (t) => e.setTitle(t),
			onDeleteElementClick: () => r.elements.deleteElement(e.id),
			onDragElementClick: (e, t) => r.elements.handleDragAndDrop(e, t),
			formElementComponent: /* @__PURE__ */ T(w, {}),
			isFirstElement: r.elements.isFirstElement(e.id),
			isLastElement: r.elements.isLastElement(e.id),
			onMoveElementUp: () => r.elements.moveUp(e.id),
			onMoveElementDown: () => r.elements.moveDown(e.id),
			isRequiredElement: a,
			isEditModeOpen: u,
			setIsEditModeOpen: () => r.elements.setEditMode(e.id),
			rulesComponent: /* @__PURE__ */ T(Z, { model: e }),
			onSaveClick: () => r.elements.setEditMode(e.id),
			conditionalCheckboxPanel: /* @__PURE__ */ T(Q, { model: e }),
			advancedOptions: /* @__PURE__ */ T(yt, {
				index: n,
				model: e
			}),
			validationErrors: d[e.id]
		})
	});
}, yt = ({ index: e, model: n }) => {
	let r = t(n.maxImages), i = t(n.buttonText), a = t(n.allowCaption);
	return /* @__PURE__ */ T(ht, {
		defaultShowAndHideLogic: !!r && !!i,
		children: /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T(m, {
			id: `image-element-max-items-${e}`,
			className: "form-element-label-input maximum-items",
			labelText: "Maximum Items",
			placeholderText: "maximum number of images allowed",
			textString: String(r),
			setTextString: (e) => n.setMaxImages(Number(e)),
			type: "number"
		}), n.type === O.PHOTOS && /* @__PURE__ */ T("div", {
			className: "condition-checkbox-panel",
			children: /* @__PURE__ */ T(f, {
				id: `allow-captions-on-images-${n.id}`,
				isChecked: a,
				onChange: () => n.setAllowCaption(!a),
				label: "Allow captions on images",
				ariaLabel: "Allow captions on images"
			})
		})] })
	});
}, bt = ({ model: e, index: n }) => {
	let r = q(), i = t(e.title), a = t(e.placeholder), o = t(e.isRequired), s = t(r.openEditElementId).includes(e.id), c = t(e.rules), l = t(e.optionSet), u = t(r.validationMap);
	return $({
		model: e,
		observables: [
			o,
			i,
			c,
			l,
			a
		]
	}), /* @__PURE__ */ T("div", {
		className: "form-element-widget-wrapper text-entry-wrapper",
		children: /* @__PURE__ */ T(b, {
			index: n,
			formElementId: e.id,
			elementType: "Dropdown",
			labelText: i,
			setLabelText: (t) => e.setTitle(t),
			onDeleteElementClick: () => r.elements.deleteElement(e.id),
			onDragElementClick: (e, t) => r.elements.handleDragAndDrop(e, t),
			formElementComponent: /* @__PURE__ */ T(Ct, {
				model: e,
				validationErrors: u[e.id] || []
			}),
			isFirstElement: r.elements.isFirstElement(e.id),
			isLastElement: r.elements.isLastElement(e.id),
			onMoveElementUp: () => r.elements.moveUp(e.id),
			onMoveElementDown: () => r.elements.moveDown(e.id),
			isRequiredElement: o,
			isEditModeOpen: s,
			setIsEditModeOpen: () => {
				r.elements.setEditMode(e.id);
			},
			rulesComponent: /* @__PURE__ */ T(Z, { model: e }),
			onSaveClick: () => r.elements.setEditMode(e.id),
			conditionalCheckboxPanel: /* @__PURE__ */ T(Q, { model: e }),
			advancedOptions: /* @__PURE__ */ T(wt, {
				index: n,
				model: e
			}),
			validationErrors: u[e.id]
		})
	});
}, xt = ({ optionSetIndex: e, model: t, options: n, OS: r, validationErrors: i }) => {
	let [a, o] = s(null);
	function c() {
		t.removeOptionSet(a), o(null);
	}
	let l = i.includes(B.OPTIONS_MUST_HAVE_LABEL_TEXT);
	function u(e) {
		return l && !e.trim() || e.length >= 513;
	}
	return /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T("ul", {
		className: "drop-down-single-option-set-list",
		children: n.map((i, a) => /* @__PURE__ */ E("li", { children: [
			/* @__PURE__ */ E("div", {
				className: "option-label-wrapper",
				children: [
					/* @__PURE__ */ T(m, {
						id: `dropdown-element-${a}`,
						className: `form-element-label-input ${u(i.label.trim("")) ? "form-builder-error" : ""}`,
						labelText: a < 1 ? `OPTION SET ${e + 1}` : `Option ${a + 1} for option set ${e + 1}`,
						placeholderText: `Option ${a + 1}`,
						textString: i.label,
						maxLength: 26,
						setTextString: (e) => t.setValue(r.id, i.id, e, "label"),
						labelIsHidden: a > 0
					}),
					l && !i.label.trim() && /* @__PURE__ */ T("span", {
						className: "error-text",
						children: "Option label text is required"
					}),
					i.label.length > 25 && /* @__PURE__ */ T("span", {
						className: "error-text",
						children: "Please enter a maximum of 25 characters"
					})
				]
			}),
			/* @__PURE__ */ T("div", {
				className: `delete-option-set-wrapper ${a === 0 && e !== 0 ? "show" : "hide"}`,
				children: /* @__PURE__ */ T(ne, {
					className: "option-set-delete-button above",
					tooltipText: "Remove option set",
					ariaLabel: "Remove the form option set",
					iconName: S.BIN,
					onButtonClick: () => o(r.id),
					isDisabled: t.optionSet.length > 1
				})
			}),
			/* @__PURE__ */ E("div", {
				className: `option-button-wrapper ${a === n.length - 1 ? "show" : "hide"} ${l && !i.label.trim() && "add-bottom-margin"}`,
				children: [/* @__PURE__ */ T(d, {
					className: "option-button-squared",
					ariaLabel: "remove option",
					content: /* @__PURE__ */ T("span", {
						className: "subtract-icon",
						children: "–"
					}),
					onButtonClick: () => t.removeOption(r.id, i.id),
					isDisabled: n.length === 2
				}), /* @__PURE__ */ T(d, {
					className: "option-button-squared",
					ariaLabel: "add new option",
					content: /* @__PURE__ */ T("span", {
						className: "add-icon",
						children: "+"
					}),
					onButtonClick: () => t.addOption(r.id)
				})]
			})
		] }, i.id))
	}), a && /* @__PURE__ */ T(p, {
		headerText: "Delete option set",
		questionText: "Are you sure you want to delete this dropdown option set?",
		onCloseClick: () => o(null),
		onConfirmClick: () => c()
	})] });
}, St = ({ optionSet: e, model: t, validationErrors: n }) => /* @__PURE__ */ E(w, { children: [n.includes(B.CONDITIONAL_EXPRESSION_IS_INCOMPLETE) && /* @__PURE__ */ T(C, {
	type: "error",
	className: "conditional-rules-error",
	children: /* @__PURE__ */ T("span", { children: "Some conditional rules are incomplete. Please make sure each rule is fully defined before saving." })
}), /* @__PURE__ */ T("ul", {
	className: "drop-down-multiple-option-set-list",
	children: e.map((r, i) => /* @__PURE__ */ E("li", { children: [e.length > 1 && /* @__PURE__ */ T(ft, {
		title: `SHOW OPTION SET ${i + 1} WHEN`,
		parent: {
			id: t.id,
			addRules: (e) => t.addExpressionToOptionSet(r.id, e.expression)
		},
		ruleType: M.SHOW,
		parentRules: r.conditionalExpression,
		hideFirstLabel: !0
	}), /* @__PURE__ */ T(xt, {
		optionSetIndex: i,
		model: t,
		options: r.options,
		OS: r,
		validationErrors: n
	})] }, r.id))
})] }), Ct = ({ model: e, validationErrors: n }) => {
	let r = t(e.optionSet);
	return /* @__PURE__ */ T("div", {
		className: "dropdown-widget",
		children: r.length === 1 ? /* @__PURE__ */ T(xt, {
			optionSetIndex: 0,
			model: e,
			options: r[0].options,
			OS: r[0],
			validationErrors: n
		}) : /* @__PURE__ */ T(St, {
			optionSet: r,
			model: e,
			validationErrors: n
		})
	});
}, wt = ({ index: e, model: n }) => {
	let r = t(n.optionSet), i = t(n.placeholder), a = t(n.isRequired);
	function o(e) {
		return e?.length >= 513;
	}
	let s = ke(n.type);
	return /* @__PURE__ */ T(ht, {
		defaultShowAndHideLogic: r.length > 1,
		children: /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T(c, {
			ariaLabel: "Add Option Set",
			onButtonClick: n.addOptionSet,
			text: "Add Option Set"
		}), a && /* @__PURE__ */ E(w, { children: [/* @__PURE__ */ T(m, {
			id: `place-holder-input-${e}`,
			className: `form-element-label-input dropdown ${o(i) ? "form-builder-error" : ""}`,
			labelText: "Placeholder Text",
			placeholderText: "Add Placeholder",
			textString: i,
			maxLength: s + 1,
			setTextString: (e) => n.setPlaceholder(e)
		}), i?.length >= s && /* @__PURE__ */ E("span", {
			className: "error-text",
			children: [
				"Please enter a maximum of ",
				s,
				" characters"
			]
		})] })] })
	});
}, Tt = ({ model: e, index: n }) => {
	let r = q(), i = t(e.isRequired), a = t(e.title), o = t(e.rules), s = t(r.openEditElementId).includes(e.id), c = t(r.validationMap);
	return $({
		model: e,
		observables: [
			i,
			a,
			o
		]
	}), /* @__PURE__ */ T("div", {
		className: "form-element-widget-wrapper text-entry-wrapper",
		children: /* @__PURE__ */ T(b, {
			index: n,
			formElementId: e.id,
			elementType: "Checkbox",
			labelText: a,
			setLabelText: (t) => e.setTitle(t),
			onDeleteElementClick: () => r.elements.deleteElement(e.id),
			onDragElementClick: (e, t) => r.elements.handleDragAndDrop(e, t),
			formElementComponent: /* @__PURE__ */ T(w, {}),
			isFirstElement: r.elements.isFirstElement(e.id),
			isLastElement: r.elements.isLastElement(e.id),
			onMoveElementUp: () => r.elements.moveUp(e.id),
			onMoveElementDown: () => r.elements.moveDown(e.id),
			isRequiredElement: i,
			isEditModeOpen: s,
			setIsEditModeOpen: () => r.elements.setEditMode(e.id),
			rulesComponent: /* @__PURE__ */ T(Z, { model: e }),
			onSaveClick: () => r.elements.setEditMode(e.id),
			conditionalCheckboxPanel: /* @__PURE__ */ T(Q, { model: e }),
			validationErrors: c[e.id]
		})
	});
}, Et = ({ id: e, value: t, setValue: n, className: r, isDisabled: i = !1, placeholder: a, maxLength: o, labelText: s, labelIsHidden: c, hideMaxLength: l }) => {
	let u = !s || c;
	return /* @__PURE__ */ E("div", {
		className: "tc-textarea-wrapper",
		children: [
			/* @__PURE__ */ T("label", {
				htmlFor: `basic-text-area-${e || ""}`,
				className: `${u ? "sr-only" : ""} basic-text-input-label`,
				children: s
			}),
			/* @__PURE__ */ T("textarea", {
				id: `basic-text-area-${e || ""}`,
				className: `tc-textarea ${r ?? ""}`,
				placeholder: a ?? "",
				value: t,
				onChange: (e) => n(e.target.value),
				disabled: i,
				maxLength: o,
				"aria-label": u ? s ?? "Add your text" : ""
			}),
			!!o && !l && /* @__PURE__ */ E("span", {
				className: "tc-length-counter",
				children: [
					t.length,
					" / ",
					o
				]
			})
		]
	});
}, Dt = ({ id: e, isChecked: t, onChange: n, label: r, isDisabled: i, ariaLabel: a, hideLabel: o }) => /* @__PURE__ */ E("label", {
	className: "basic-checkbox-wrapper",
	children: [
		/* @__PURE__ */ T("svg", {
			className: "basic-checkbox-symbol",
			"aria-hidden": "true",
			children: /* @__PURE__ */ T("symbol", {
				id: "check",
				viewBox: "0 0 18 6",
				children: /* @__PURE__ */ T("polyline", {
					points: "2 6 4.5 8 9.5 1",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: "3"
				})
			})
		}),
		/* @__PURE__ */ E("div", {
			className: `basic-checkbox-container ${i ? "disabled-checkbox" : ""}`,
			children: [/* @__PURE__ */ T("input", {
				className: "basic-checkbox-input",
				disabled: i,
				id: e,
				type: "checkbox",
				checked: t,
				onChange: n,
				"aria-label": a,
				"aria-checked": t
			}), /* @__PURE__ */ T("span", {
				className: "basic-checkbox",
				"aria-hidden": "true",
				children: /* @__PURE__ */ T("span", { children: /* @__PURE__ */ T("svg", {
					width: "12px",
					height: "10px",
					children: /* @__PURE__ */ T("use", { xlinkHref: "#check" })
				}) })
			})]
		}),
		/* @__PURE__ */ T("span", {
			className: o ? "sr-only" : "label-text",
			children: r
		})
	]
}), Ot = ({ model: e, index: n }) => {
	let r = q(), a = t(e.title), o = t(e.placeholder), s = t(e.isRequired), c = t(r.openEditElementId).includes(e.id), l = t(e.rules), u = t(e.optionSet), d = t(e.description), f = t(e.imageLayout), p = t(e.elementSubmitButtonText), m = t(r.config.canAddElements), h = t(e.showResultsAfterVoting), g = t(r.elements.FormTemplate), _ = t(r.validationMap);
	return i(() => {
		r.validateForm({
			validateAllFields: !1,
			validateVoteText: !0
		});
	}, [p]), $({
		model: e,
		observables: [
			s,
			a,
			l,
			u,
			o,
			d,
			f,
			p,
			h
		]
	}), /* @__PURE__ */ E("div", {
		className: "form-element-widget-wrapper text-entry-wrapper",
		children: [/* @__PURE__ */ T(b, {
			index: n,
			formElementId: e.id,
			elementType: g === G.POLL ? "Poll" : "Single Select",
			labelTextName: "Title",
			labelText: a,
			setLabelText: (t) => e.setTitle(t),
			onDeleteElementClick: m ? () => r.elements.deleteElement(e.id) : void 0,
			onDragElementClick: (e, t) => r.elements.handleDragAndDrop(e, t),
			formElementComponent: /* @__PURE__ */ T(At, {
				model: e,
				validationErrors: _[e.id] || []
			}),
			isFirstElement: r.elements.isFirstElement(e.id),
			isLastElement: r.elements.isLastElement(e.id),
			onMoveElementUp: () => r.elements.moveUp(e.id),
			onMoveElementDown: () => r.elements.moveDown(e.id),
			isRequiredElement: s,
			isEditModeOpen: c,
			setIsEditModeOpen: () => {
				r.elements.setEditMode(e.id);
			},
			rulesComponent: /* @__PURE__ */ T(Z, { model: e }),
			onSaveClick: () => r.elements.setEditMode(e.id),
			conditionalCheckboxPanel: /* @__PURE__ */ T(Q, { model: e }),
			validationErrors: _[e.id]
		}), /* @__PURE__ */ T(v, {
			type: x.SUBMIT_BUTTON,
			elementId: `${e.id}-element-submit-button`,
			formButtonType: "Vote Button",
			submitButtonText: p,
			setSubmitButtonText: (t) => e.setElementSubmitButtonText(t),
			validationErrors: _[`${e.id}-vote-button`] || []
		})]
	});
}, kt = ({ model: e, options: n, OS: r, validationErrors: i }) => {
	let a = t(e.description), o = t(e.imageLayout), s = t(e.showResultsAfterVoting), u = t(e.imageAssets), f = q(), p = i.includes(B.OPTIONS_MUST_HAVE_LABEL_TEXT);
	function h(e) {
		return p && !e.trim() || e.length >= 513;
	}
	return /* @__PURE__ */ E(w, { children: [
		/* @__PURE__ */ T(Et, {
			id: `${e.id}-description-text-area`,
			labelText: "Description",
			className: "form-builder-textarea single-select-description-textarea",
			value: a ?? "",
			setValue: (t) => e.setDescription(t),
			maxLength: 513,
			hideMaxLength: !0,
			labelIsHidden: !0
		}),
		(a?.length ?? 0) > 512 && /* @__PURE__ */ T("span", {
			className: "error-text",
			style: { top: 0 },
			children: "Please enter a maximum of 512 characters"
		}),
		/* @__PURE__ */ T("h3", {
			className: "form-builder-widget-section-heading",
			style: { margin: "16px 16px 0" },
			children: "Options"
		}),
		/* @__PURE__ */ T("ul", {
			className: `drop-down-single-option-set-list ${o}`,
			children: n.map((t, i) => /* @__PURE__ */ E("li", { children: [/* @__PURE__ */ E("div", {
				className: "option-label-wrapper",
				children: [/* @__PURE__ */ T("div", {
					className: "image-upload-wrapper",
					children: /* @__PURE__ */ T(l, {
						accessibileName: `Option ${i + 1} image`,
						asset: t.imageAssetId ? u[t.imageAssetId] : void 0,
						handleMediaLibrary: () => e.handleImageUpload(r.id, t.id, f),
						className: "",
						removeAsset: () => e.handleRemoveImage(r.id, t.id)
					})
				}), /* @__PURE__ */ E("div", {
					className: "text-entry-wrapper",
					children: [
						/* @__PURE__ */ T(m, {
							id: `dropdown-element-${i}`,
							className: `form-element-label-input ${h(t.label.trim("")) ? "form-builder-error" : ""}`,
							placeholderText: `Option ${i + 1}`,
							textString: t.label,
							maxLength: 257,
							setTextString: (n) => e.setValue(r.id, t.id, n, "label"),
							labelIsHidden: !0,
							labelText: `Add Option ${i + 1} title text`
						}),
						p && !t.label.trim() && /* @__PURE__ */ T("span", {
							className: "error-text",
							children: "Option label text is required"
						}),
						t.label.length > 256 && /* @__PURE__ */ T("span", {
							className: "error-text",
							children: "Please enter a maximum of 256 characters"
						}),
						/* @__PURE__ */ T(Et, {
							id: `dropdown-description-${i}`,
							placeholder: "Add description",
							className: "form-builder-textarea single-select-description-textarea",
							value: t.description ?? "",
							setValue: (n) => e.setValue(r.id, t.id, n, "description"),
							maxLength: 513,
							hideMaxLength: !0,
							labelIsHidden: !0,
							labelText: `description of option ${i + 1}`
						}),
						t?.description?.length > 512 && /* @__PURE__ */ T("span", {
							className: "error-text",
							style: { top: 0 },
							children: "Please enter a maximum of 512 characters"
						})
					]
				})]
			}), /* @__PURE__ */ T("div", {
				className: `option-button-wrapper ${i > 1 ? "show" : "hide"} ${p && !t.label.trim() && "add-bottom-margin"}`,
				children: /* @__PURE__ */ T(d, {
					className: "option-button-squared",
					ariaLabel: "remove option",
					content: /* @__PURE__ */ T(ie, {
						iconName: S.BIN,
						sizeInPx: "12",
						color: "#666"
					}),
					onButtonClick: () => e.removeOption(r.id, t.id),
					isDisabled: n.length === 2
				})
			})] }, t.id))
		}),
		n.length < 20 && /* @__PURE__ */ T("div", {
			className: "add-option-wrapper",
			children: /* @__PURE__ */ T(c, {
				ariaLabel: "add new option",
				text: "Add Option",
				onButtonClick: () => e.addOption(r.id)
			})
		}),
		/* @__PURE__ */ E("div", {
			className: "radio-button-select-section",
			children: [
				/* @__PURE__ */ T("h3", {
					className: "form-builder-widget-section-heading",
					children: "Image Layout"
				}),
				/* @__PURE__ */ T(re, {
					id: 1,
					text: "None",
					textDescription: "No images are shown for the options",
					isChecked: o === k.NONE,
					onClick: () => e.setImageLayout(k.NONE)
				}, 1),
				/* @__PURE__ */ T(re, {
					id: 2,
					text: "Inline",
					textDescription: "Images appear beside the text option",
					isChecked: o === k.INLINE,
					onClick: () => e.setImageLayout(k.INLINE)
				}, 2),
				/* @__PURE__ */ T(re, {
					id: 3,
					text: "Two Columns",
					textDescription: "Images appear above the text option, with two options shown per row",
					isChecked: o === k.TWO_COLUMN,
					onClick: () => e.setImageLayout(k.TWO_COLUMN)
				}, 3)
			]
		}),
		/* @__PURE__ */ T("h3", {
			className: "form-builder-widget-section-heading",
			style: { margin: "16px 16px 0" },
			children: "Behaviour"
		}),
		/* @__PURE__ */ T("div", {
			className: "checkbox-wrapper",
			children: /* @__PURE__ */ T(Dt, {
				id: `required-checkbox-for-input-${e.id}`,
				isChecked: s,
				onChange: (t) => e.setShowResultsAfterVoting(t.target.checked),
				label: "Show results after voting",
				ariaLabel: "Show results after voting"
			})
		})
	] });
}, At = ({ model: e, validationErrors: n }) => {
	let r = t(e.optionSet);
	return /* @__PURE__ */ T("div", {
		className: "single-select-widget",
		children: /* @__PURE__ */ T(kt, {
			model: e,
			options: r[0].options,
			OS: r[0],
			validationErrors: n
		})
	});
};
//#endregion
//#region src/components/ElementsMapper.tsx
function jt(e, t, n) {
	switch (e.type) {
		case O.TEXTENTRY: return /* @__PURE__ */ T(gt, {
			model: new Y(e, n),
			index: t
		});
		case O.TEXTAREA: return /* @__PURE__ */ T(gt, {
			model: new Y(e, n),
			index: t
		});
		case O.PHOTOS: return /* @__PURE__ */ T(vt, {
			model: new X(e, n),
			index: t
		});
		case O.VIDEOS: return /* @__PURE__ */ T(vt, {
			model: new X(e, n),
			index: t
		});
		case O.FILES: return /* @__PURE__ */ T(vt, {
			model: new X(e, n),
			index: t
		});
		case O.DROPDOWN: return /* @__PURE__ */ T(bt, {
			model: new H(e, n),
			index: t
		});
		case O.ORGUSERSEARCH: return /* @__PURE__ */ T(gt, {
			model: new Y(e, n),
			index: t
		});
		case O.SINGLEOPTION: return /* @__PURE__ */ T(pt, {
			model: new ct(e, n),
			index: t
		});
		case O.CHECKBOX: return /* @__PURE__ */ T(Tt, {
			model: new lt(e, n),
			index: t
		});
		case O.SINGLESELECT:
		case O.POLL: return /* @__PURE__ */ T(Ot, {
			model: new W(e, n),
			index: t
		});
	}
}
var Mt = ({ element: e, idx: n }) => {
	let r = q(), s = o(null);
	return t(r.validationMap), i(() => {
		let t = (t) => {
			t.relatedTarget && (s?.current?.contains(t.relatedTarget) || r.elements.addDirtyElement([e.id]));
		};
		return e.id && s.current?.addEventListener("focusout", t), () => {
			s.current?.removeEventListener("focusout", t);
		};
	}, [e.id]), /* @__PURE__ */ T("div", {
		className: "form-element-wrapper",
		ref: s,
		children: a(() => jt(e, n, r), [
			e,
			n,
			r
		])
	});
}, Nt = () => {
	let e = q(), n = o(null), r = t(e.formSubmitButtonText), a = t(e.validationMap);
	return i(() => {
		e.validateForm();
	}, [r, t(e.submitElementIsDirty)]), J(n, e.settings.setSubmitElementIsDirty), /* @__PURE__ */ T("div", {
		className: "form-element-wrapper submit-button-element-wrapper",
		ref: n,
		children: /* @__PURE__ */ T(v, {
			type: x.SUBMIT_BUTTON,
			elementId: "submit-1",
			formButtonType: "Submit Button",
			submitButtonText: r,
			setSubmitButtonText: e.settings.setFormSubmitButtonText,
			validationErrors: a.submit
		})
	});
}, Pt = () => {
	let e = q(), n = o(null), r = t(e.viewFormButtonText), a = t(e.validationMap), s = t(e.elements.FormTemplate);
	return i(() => {
		e.validateForm();
	}, [r, t(e.viewFormElementIsDirty)]), J(n, e.settings.setViewFormElementIsDirty), /* @__PURE__ */ T("div", {
		className: "form-element-wrapper view-form-element-wrapper",
		ref: n,
		children: /* @__PURE__ */ T(v, {
			type: x.VIEW_FORM_BUTTON,
			elementId: "view-1",
			formButtonType: s === G.POLL ? "View Poll Button" : "View Form Button",
			submitButtonText: r,
			setSubmitButtonText: e.settings.setViewFormButtonText,
			validationErrors: a.view
		})
	});
}, Ft = ({ service: e }) => /* @__PURE__ */ T(nt, {
	service: e,
	children: /* @__PURE__ */ T(It, {})
}), It = () => {
	let e = q(), n = t(e.formBuilderData), r = t(e.formSubmitButtonText), a = t(e.viewFormButtonText), o = t(e.config.canAddElements), s = t(e.config.showEmail), c = t(e.config.hideSubmitButton);
	return i(() => {
		e.validateForm();
	}, [
		n,
		r,
		a
	]), /* @__PURE__ */ E("main", {
		className: "thrive-form-builder",
		children: [/* @__PURE__ */ E(ee, { children: [
			n?.map((e, t) => /* @__PURE__ */ T(Mt, {
				idx: t,
				element: e
			}, e?.id)),
			o && /* @__PURE__ */ T(dt, {}),
			!c && /* @__PURE__ */ T(Nt, {}),
			/* @__PURE__ */ T(Pt, {})
		] }), s && /* @__PURE__ */ T(st, {})]
	});
};
//#endregion
export { Ze as FBService, Ft as FormBuilder, Xe as FormBuilderService };
